var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 233 0.5 L 210.5 3 L 209.5 4 L 200.5 5 L 199.5 6 L 188.5 8 L 184.5 10 L 181.5 10 L 166.5 15 L 158.5 19 L 156.5 19 L 133.5 30 L 109.5 45 L 93.5 57 L 63 86.5 L 47 106.5 L 37 121.5 L 32 131.5 L 30 133.5 L 19 156.5 L 19 158.5 L 15 166.5 L 10 181.5 L 10 184.5 L 8 188.5 L 8 191.5 L 5 200.5 L 5 204.5 L 3 210.5 L 3 215.5 L 2 216.5 L 2 223.5 L 1 224.5 L 0.5 233 L 0 0 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 279.5 0 L 512 0 L 512 232.5 L 511 232.5 L 511 224.5 L 510 223.5 L 509 210.5 L 508 209.5 L 507 200.5 L 506 199.5 L 504 188.5 L 502 184.5 L 502 181.5 L 498 169.5 L 496 166.5 L 495 161.5 L 493 158.5 L 493 156.5 L 483 135.5 L 481 133.5 L 475 121.5 L 459 98.5 Q 443.53 78.48 424.5 62 L 405.5 47 L 390.5 37 L 378.5 31 L 376.5 29 L 355.5 19 L 353.5 19 L 345.5 15 L 330.5 10 L 327.5 10 L 323.5 8 L 320.5 8 L 311.5 5 L 307.5 5 L 306.5 4 L 302.5 4 L 301.5 3 L 296.5 3 L 295.5 2 L 279.5 1 L 279.5 0 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0.5 278 L 1 287.5 L 2 288.5 L 2 294.5 L 3 295.5 L 4 306.5 L 5 307.5 L 6 315.5 L 10 327.5 L 10 330.5 L 14 342.5 L 16 345.5 L 17 350.5 L 19 353.5 L 19 355.5 L 29 376.5 L 31 378.5 L 37 390.5 L 53 413.5 Q 68.18 432.82 86.5 449 L 102.5 462 L 121.5 475 L 126.5 477 L 135.5 483 L 161.5 495 L 166.5 496 L 169.5 498 L 181.5 502 L 188.5 503 L 196.5 506 L 200.5 506 L 201.5 507 L 210.5 508 L 211.5 509 L 216.5 509 L 217.5 510 L 223.5 510 L 224.5 511 L 233 511.5 L 0 512 L 0.5 278 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 511.5 279 L 512 512 L 279 511.5 L 287.5 511 L 288.5 510 L 294.5 510 L 295.5 509 Q 300.25 510.25 301.5 508 L 306.5 508 L 307.5 507 L 315.5 506 L 327.5 502 L 330.5 502 L 342.5 498 L 345.5 496 L 350.5 495 L 353.5 493 L 355.5 493 L 376.5 483 L 378.5 481 L 390.5 475 L 413.5 459 Q 433.53 443.53 450 424.5 L 465 405.5 L 475 390.5 L 481 378.5 L 483 376.5 L 493 355.5 L 493 353.5 L 497 345.5 L 502 330.5 L 502 327.5 L 506 315.5 L 506 311.5 L 507 310.5 L 508 301.5 L 509 300.5 L 509 295.5 L 510 294.5 L 510 288.5 L 511 287.5 L 511.5 279 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 233.5 0 L 245 0.5 L 233.5 1 L 233.5 0 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 267.5 0 L 279 0.5 L 267.5 1 L 267.5 0 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 224.5 1 L 230 1.5 L 224.5 2 L 224.5 1 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 282.5 1 L 288 1.5 L 282.5 2 L 282.5 1 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 216.5 2 L 222 2.5 L 216.5 3 L 216.5 2 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 290.5 2 L 296 2.5 L 290.5 3 L 290.5 2 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 210.5 3 L 215 3.5 L 210.5 4 L 210.5 3 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 297.5 3 L 302 3.5 L 297.5 4 L 297.5 3 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 205.5 4 L 209 4.5 L 205.5 5 L 205.5 4 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 303.5 4 L 307 4.5 L 303.5 5 L 303.5 4 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 200.5 5 L 204 5.5 L 196.5 7 L 196.5 6 Q 199.75 6.75 200.5 5 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 308.5 5 L 312 5.5 L 308.5 6 L 308.5 5 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 313.5 6 L 316 6.5 L 313.5 7 L 313.5 6 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 192.5 7 L 195 7.5 L 192.5 8 L 192.5 7 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 317.5 7 L 320 7.5 L 317.5 8 L 317.5 7 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 188.5 8 L 191 8.5 L 185.5 10 L 185.5 9 L 188.5 8 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 321.5 8 L 327 9.5 L 324.5 10 L 321.5 9 L 321.5 8 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 181.5 10 L 184 10.5 L 175.5 13 L 175.5 12 L 181.5 10 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 328.5 10 L 334 11.5 L 331.5 12 L 328.5 11 L 328.5 10 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 335.5 12 L 337 12.5 L 335.5 13 L 335.5 12 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 172.5 13 L 174 13.5 L 164.5 17 L 164.5 16 L 172.5 13 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 338.5 13 L 340 13.5 L 338.5 14 L 338.5 13 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 341.5 14 L 348 16.5 L 346.5 17 L 341.5 15 L 341.5 14 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 161.5 17 L 163 17.5 L 159.5 19 L 159.5 18 L 161.5 17 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 349.5 17 L 353 18.5 L 351.5 19 L 349 17.5 L 349.5 17 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 156.5 19 L 158 19.5 L 152.5 22 L 152.5 21 L 156.5 19 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 354.5 19 L 362 22.5 L 360.5 23 L 354.5 20 L 354.5 19 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 149.5 22 L 151 22.5 L 126.5 35 L 107.5 48 L 107 47.5 L 109.5 45 L 126.5 34 L 149.5 22 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 363.5 23 L 378 30.5 L 376.5 30 L 363.5 24 L 363.5 23 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 379.5 31 Q 420.59 53.41 450 87.5 L 465 106.5 L 481 132.5 Q 480 134 479 131.5 L 474 121.5 L 458 98.5 L 448 86.5 L 425.5 64 L 405.5 48 L 390.5 38 L 380.5 33 Q 378 32 379.5 31 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 105.5 48 L 106 48.5 L 103.5 51 Q 81.82 65.82 65 85.5 L 51 102.5 L 38 121.5 L 22.5 151 L 22 149.5 L 34 126.5 L 47 106.5 Q 64.44 82.44 86.5 63 L 105.5 48 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 481.5 134 L 489 148.5 L 488 148.5 L 481 134.5 L 481.5 134 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 489.5 150 L 489.5 151 L 489.5 150 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 21.5 152 L 22 153.5 L 19.5 158 L 19 156.5 L 21.5 152 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 490.5 152 L 495 162.5 L 494 162.5 L 490 153.5 L 490.5 152 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 18.5 159 L 19 160.5 L 17.5 163 L 17 161.5 L 18.5 159 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 16.5 164 L 17 165.5 L 13.5 174 L 13 172.5 L 16.5 164 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 495.5 164 L 496 165.5 L 495 165.5 L 495.5 164 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 496.5 167 L 502 183.5 L 501 183.5 L 496 168.5 L 496.5 167 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 12.5 175 L 13 177.5 L 10.5 184 L 10 181.5 L 12.5 175 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 9.5 185 L 10 187.5 L 8.5 191 L 8 188.5 L 9.5 185 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 502.5 185 L 504 190.5 L 503 190.5 L 502 187.5 L 502.5 185 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 7.5 192 L 8 194.5 L 7 194.5 L 7.5 192 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 504.5 192 L 505 194.5 L 504 194.5 L 504.5 192 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 6.5 196 L 7 198.5 L 6 198.5 L 6.5 196 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 505.5 196 L 507 203.5 L 506 203.5 Q 506.75 200.25 505 199.5 L 505.5 196 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 5.5 200 L 6 203.5 L 5 203.5 L 5.5 200 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 4.5 205 L 5 208.5 L 4 208.5 L 4.5 205 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 507.5 205 L 508 208.5 L 507 208.5 L 507.5 205 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 3.5 210 L 4 214.5 L 3 214.5 L 3.5 210 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 508.5 210 L 509 214.5 L 508 214.5 L 508.5 210 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 2.5 216 L 3 221.5 L 2 221.5 L 2.5 216 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 509.5 217 L 510 221.5 L 509 221.5 L 509.5 217 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 1.5 224 L 2 229.5 L 1 229.5 L 1.5 224 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 510.5 224 L 511 230.5 L 510 230.5 L 510.5 224 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 0.5 233 L 1 244.5 L 0 244.5 L 0.5 233 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 511.5 233 L 512 244.5 L 511 244.5 L 511.5 233 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 0.5 267 L 1 277.5 L 0 277.5 L 0.5 267 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 511.5 273 L 512 278.5 L 511 278.5 L 511.5 273 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 1.5 281 L 2 287.5 L 1 287.5 L 1.5 281 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 510.5 284 L 511 287.5 L 510 287.5 L 510.5 284 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 2.5 290 L 3 294.5 L 2 294.5 L 2.5 290 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 509.5 292 L 510 294.5 L 509 294.5 L 509.5 292 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 3.5 297 L 4 300.5 L 3 300.5 L 3.5 297 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 508.5 299 L 509 300.5 L 508 300.5 L 508.5 299 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 4.5 303 L 5 306.5 L 4 306.5 L 4.5 303 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 507.5 304 L 508 306.5 L 507 306.5 L 507.5 304 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 5.5 308 L 6 310.5 L 5 310.5 L 5.5 308 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 506.5 309 L 507 310.5 L 506 310.5 L 506.5 309 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 6.5 312 L 7 315.5 L 6 315.5 L 6.5 312 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 505.5 314 L 506 315.5 L 505 315.5 L 505.5 314 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 7.5 317 L 8 319.5 L 7 319.5 L 7.5 317 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 504.5 318 L 505 319.5 L 504 319.5 L 504.5 318 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 8.5 321 L 10 326.5 L 9 326.5 L 8 323.5 L 8.5 321 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 503.5 322 L 504 323.5 L 503 323.5 L 503.5 322 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 502.5 325 L 503 326.5 L 502 326.5 L 502.5 325 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 10.5 328 L 16 344.5 L 15 344.5 L 10 330.5 L 10.5 328 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 501.5 329 L 502 330.5 L 501 330.5 L 501.5 329 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 500.5 332 L 501 333.5 L 500 333.5 L 500.5 332 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 499.5 335 L 500 336.5 L 499 336.5 L 499.5 335 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 498.5 338 L 499 339.5 L 498 339.5 L 498.5 338 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 497.5 341 L 498 342.5 L 497 342.5 L 497.5 341 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 496.5 344 L 497 345.5 L 496 345.5 L 496.5 344 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 16.5 346 L 22 359.5 L 21 359.5 L 16 347.5 L 16.5 346 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 495.5 347 L 495.5 348 L 495.5 347 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 494.5 349 L 495 350.5 L 494 350.5 L 494.5 349 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 493.5 352 L 493.5 353 L 493.5 352 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 492.5 354 L 493 355.5 L 492 355.5 L 492.5 354 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 491.5 357 L 491.5 358 L 491.5 357 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 490.5 359 L 490.5 360 L 490.5 359 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 22.5 361 L 22.5 362 L 22.5 361 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 489.5 361 L 490 362.5 L 487.5 367 L 487 365.5 L 489.5 361 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 23.5 363 L 31 377.5 Q 30 379 29 376.5 L 23 364.5 L 23.5 363 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 486.5 368 L 486.5 369 L 486.5 368 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 485.5 370 L 485.5 371 L 485.5 370 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 484.5 372 L 484.5 373 L 484.5 372 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 483.5 374 L 483 375.5 L 481.5 378 L 482 376.5 L 483.5 374 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 31.5 379 L 38 390.5 L 54 413.5 Q 68.73 432.27 86.5 448 L 102.5 461 L 126 476.5 L 124.5 476 L 109.5 467 L 93.5 455 L 63 425.5 L 47 405.5 L 34 385.5 L 31 379.5 L 31.5 379 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 480.5 379 L 480.5 380 L 480.5 379 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 479.5 381 L 479.5 382 L 479.5 381 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 478.5 383 L 478 384.5 L 476.5 387 L 477 385.5 L 478.5 383 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 475.5 388 L 475 389.5 L 473.5 392 L 474 390.5 L 475.5 388 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 472.5 393 Q 474 394 471.5 395 Q 470 394 472.5 393 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 470.5 396 Q 472 397 469.5 398 Q 468 397 470.5 396 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 468.5 399 Q 470 400 467.5 401 Q 466 400 468.5 399 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 466.5 402 Q 468 403 465.5 404 Q 464 403 466.5 402 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 464.5 405 L 465 405.5 L 462.5 408 L 462 407.5 L 464.5 405 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 461.5 409 L 462 409.5 L 459.5 412 L 459 411.5 L 461.5 409 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 458.5 413 L 459 413.5 L 455.5 417 L 455 416.5 L 458.5 413 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 454.5 418 L 455 418.5 L 450.5 423 L 450 422.5 L 454.5 418 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 449.5 424 L 450 424.5 L 440.5 434 L 440 433.5 L 449.5 424 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 433.5 440 L 434 440.5 L 424.5 450 L 424 449.5 L 433.5 440 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 421.5 451 L 422 451.5 L 418.5 455 L 418 454.5 L 421.5 451 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 416.5 455 L 417 455.5 L 413.5 459 L 413 458.5 L 416.5 455 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 411.5 459 L 412 459.5 L 409.5 462 L 409 461.5 L 411.5 459 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 407.5 462 L 408 462.5 L 405.5 465 L 405 464.5 L 407.5 462 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 403.5 465 Q 405 466 402.5 467 Q 401 466 403.5 465 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 400.5 467 Q 402 468 399.5 469 Q 398 468 400.5 467 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 397.5 469 Q 399 470 396.5 471 Q 395 470 397.5 469 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 394.5 471 Q 396 472 393.5 473 Q 392 472 394.5 471 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 391.5 473 Q 393 474 390.5 475 Q 389 474 391.5 473 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 388.5 475 L 388.5 476 L 388.5 475 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 386.5 476 Q 388 477 385.5 478 L 383.5 479 Q 382 478 384.5 477 L 386.5 476 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 127.5 477 L 133 480.5 L 131.5 480 Q 127.5 479.5 127.5 477 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 381.5 479 L 381.5 480 L 381.5 479 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 379.5 480 L 379.5 481 L 379.5 480 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 134.5 481 L 149 488.5 L 147.5 489 L 135.5 483 Q 133 482 134.5 481 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 377.5 481 Q 379 482 376.5 483 Q 375 482 377.5 481 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 374.5 483 L 374.5 484 L 374.5 483 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 372.5 484 L 372.5 485 L 372.5 484 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 370.5 485 L 370.5 486 L 370.5 485 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 368.5 486 L 368.5 487 L 368.5 486 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 366.5 487 L 366.5 488 L 366.5 487 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 363.5 488 L 365 488.5 L 363.5 489 L 363.5 488 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 150.5 489 L 150.5 490 L 150.5 489 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 361.5 489 L 361.5 490 L 361.5 489 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 152.5 490 L 156 491.5 L 154.5 492 L 152 490.5 L 152.5 490 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 359.5 490 L 359.5 491 L 359.5 490 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 357.5 491 L 357.5 492 L 357.5 491 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 157.5 492 L 166 495.5 L 164.5 496 L 157.5 493 L 157.5 492 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 354.5 492 L 356 492.5 L 354.5 493 L 354.5 492 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 352.5 493 L 352.5 494 L 352.5 493 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 349.5 494 L 351 494.5 L 349.5 495 L 349.5 494 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 347.5 495 L 347.5 496 L 347.5 495 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 167.5 496 L 184 501.5 L 181.5 502 L 169.5 498 L 167 496.5 L 167.5 496 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 344.5 496 L 344.5 497 L 344.5 496 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 341.5 497 L 343 497.5 L 341.5 498 L 341.5 497 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 338.5 498 L 340 498.5 L 338.5 499 L 338.5 498 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 335.5 499 L 337 499.5 L 335.5 500 L 335.5 499 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 332.5 500 L 334 500.5 L 332.5 501 L 332.5 500 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 329.5 501 L 331 501.5 L 329.5 502 L 329.5 501 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 185.5 502 L 188 502.5 L 185.5 503 L 185.5 502 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 325.5 502 L 327 502.5 L 325.5 503 L 325.5 502 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 189.5 503 L 195 504.5 L 192.5 505 L 189.5 504 L 189.5 503 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 322.5 503 L 324 503.5 L 322.5 504 L 322.5 503 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 318.5 504 L 320 504.5 L 318.5 505 L 318.5 504 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 196.5 505 L 200 505.5 L 196.5 506 L 196.5 505 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 314.5 505 L 316 505.5 L 314.5 506 L 314.5 505 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 201.5 506 L 210 507.5 L 205.5 508 Q 204.75 506.25 201.5 507 L 201.5 506 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 309.5 506 L 311 506.5 L 309.5 507 L 309.5 506 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 304.5 507 L 307 507.5 L 304.5 508 L 304.5 507 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 211.5 508 L 216 508.5 L 211.5 509 L 211.5 508 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 299.5 508 L 301 508.5 L 299.5 509 L 299.5 508 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 217.5 509 L 222 509.5 L 217.5 510 L 217.5 509 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 292.5 509 L 295 509.5 L 292.5 510 L 292.5 509 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 224.5 510 L 231 510.5 L 224.5 511 L 224.5 510 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 284.5 510 L 288 510.5 L 284.5 511 L 284.5 510 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 233.5 511 L 239 511.5 L 233.5 512 L 233.5 511 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(38,100,239)",
    stroke: "rgb(38,100,239)",
    strokeWidth: 1,
    opacity: 0.4980392156862745,
    d: "M 272.5 511 L 279 511.5 L 272.5 512 L 272.5 511 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 245.5 0 L 254 0.5 L 245.5 1 L 245.5 0 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 258.5 0 L 267 0.5 L 258.5 1 L 258.5 0 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 230.5 1 L 233 1.5 L 230.5 2 L 230.5 1 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 279.5 1 L 282 1.5 L 279.5 2 L 279.5 1 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 222.5 2 L 224 2.5 L 222.5 3 L 222.5 2 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 288.5 2 L 290 2.5 L 288.5 3 L 288.5 2 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 215.5 3 L 217 3.5 L 215.5 4 L 215.5 3 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 295.5 3 L 297 3.5 L 295.5 4 L 295.5 3 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 209.5 4 L 211 4.5 L 209.5 5 L 209.5 4 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 301.5 4 L 303 4.5 L 301.5 5 L 301.5 4 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 204.5 5 L 206 5.5 L 204.5 6 L 204.5 5 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 306.5 5 L 308 5.5 L 306.5 6 L 306.5 5 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 200.5 6 L 200.5 7 L 200.5 6 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 311.5 6 L 313 6.5 L 311.5 7 L 311.5 6 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 195.5 7 L 197 7.5 L 195.5 8 L 195.5 7 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 315.5 7 L 317 7.5 L 315.5 8 L 315.5 7 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 191.5 8 L 193 8.5 L 191.5 9 L 191.5 8 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 319.5 8 L 321 8.5 L 319.5 9 L 319.5 8 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 188.5 9 L 188.5 10 L 188.5 9 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 323.5 9 L 323.5 10 L 323.5 9 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 184.5 10 L 184.5 11 L 184.5 10 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 327.5 10 L 327.5 11 L 327.5 10 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 181.5 11 L 181.5 12 L 181.5 11 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 330.5 11 L 330.5 12 L 330.5 11 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 178.5 12 L 178.5 13 L 178.5 12 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 333.5 12 L 335 12.5 L 333.5 13 L 333.5 12 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 174.5 13 L 176 13.5 L 174.5 14 L 174.5 13 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 336.5 13 L 338 13.5 L 336.5 14 L 336.5 13 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 172.5 14 L 172.5 15 L 172.5 14 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 339.5 14 L 341 14.5 L 339.5 15 L 339.5 14 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 169.5 15 L 169.5 16 L 169.5 15 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 342.5 15 L 342.5 16 L 342.5 15 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 166.5 16 L 166.5 17 L 166.5 16 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 345.5 16 L 345.5 17 L 345.5 16 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 163.5 17 L 163.5 18 L 163.5 17 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 348.5 17 L 348.5 18 L 348.5 17 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 161.5 18 L 161.5 19 L 161.5 18 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 350.5 18 L 350.5 19 L 350.5 18 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 158.5 19 L 158.5 20 L 158.5 19 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 353.5 19 L 353.5 20 L 353.5 19 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 156.5 20 L 156.5 21 L 156.5 20 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 355.5 20 L 355.5 21 L 355.5 20 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 154.5 21 L 154.5 22 L 154.5 21 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 357.5 21 L 357.5 22 L 357.5 21 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 151.5 22 L 151.5 23 L 151.5 22 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 359.5 22 L 359.5 23 L 359.5 22 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 149.5 23 L 149.5 24 L 149.5 23 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 362.5 23 L 362.5 24 L 362.5 23 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 147.5 24 L 147.5 25 L 147.5 24 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 364.5 24 L 364.5 25 L 364.5 24 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 145.5 25 L 145.5 26 L 145.5 25 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 366.5 25 L 366.5 26 L 366.5 25 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 143.5 26 L 143.5 27 L 143.5 26 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 368.5 26 L 368.5 27 L 368.5 26 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 141.5 27 L 141.5 28 L 141.5 27 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 370.5 27 L 370.5 28 L 370.5 27 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 139.5 28 L 139.5 29 L 139.5 28 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 372.5 28 L 372.5 29 L 372.5 28 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 137.5 29 L 137.5 30 L 137.5 29 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 374.5 29 L 374.5 30 L 374.5 29 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 135.5 30 L 135.5 31 L 135.5 30 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 376.5 30 L 376.5 31 L 376.5 30 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 133.5 31 L 133.5 32 L 133.5 31 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 378.5 31 L 378.5 32 L 378.5 31 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 130.5 33 L 130.5 34 L 130.5 33 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 381.5 33 L 381.5 34 L 381.5 33 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 128.5 34 L 128.5 35 L 128.5 34 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 383.5 34 L 383.5 35 L 383.5 34 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 126.5 35 L 126.5 36 L 126.5 35 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 385.5 35 L 385.5 36 L 385.5 35 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 123.5 37 L 123.5 38 L 123.5 37 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 388.5 37 L 388.5 38 L 388.5 37 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 121.5 38 Q 123 39 120.5 40 Q 119 39 121.5 38 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 390.5 38 Q 393 39 391.5 40 Q 389 39 390.5 38 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 118.5 40 Q 120 41 117.5 42 Q 116 41 118.5 40 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 393.5 40 L 393.5 41 L 393.5 40 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 115.5 42 L 115.5 43 L 115.5 42 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 396.5 42 L 396.5 43 L 396.5 42 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 112.5 44 L 112.5 45 L 112.5 44 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 399.5 44 Q 402 45 400.5 46 Q 398 45 399.5 44 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 109.5 46 Q 111 47 108.5 48 Q 107 47 109.5 46 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 402.5 46 Q 405 47 403.5 48 Q 401 47 402.5 46 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 106.5 48 Q 108 49 105.5 50 Q 104 49 106.5 48 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 405.5 48 Q 408 49 406.5 50 Q 404 49 405.5 48 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 102.5 51 L 103 51.5 L 100.5 54 L 100 53.5 L 102.5 51 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 409.5 51 L 412 53.5 L 411.5 54 L 409 51.5 L 409.5 51 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 413.5 54 L 416 56.5 L 415.5 57 L 413 54.5 L 413.5 54 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 97.5 55 Q 99 56 96.5 57 Q 95 56 97.5 55 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 93.5 58 L 94 58.5 L 90.5 62 L 90 61.5 L 93.5 58 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 419.5 59 L 422 61.5 L 421.5 62 L 419 59.5 L 419.5 59 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 86.5 64 L 87 64.5 L 80.5 71 L 80 70.5 L 86.5 64 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 425.5 64 L 433 71.5 L 432.5 72 L 425 64.5 L 425.5 64 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 438.5 77 L 448 86.5 L 447.5 87 L 438 77.5 L 438.5 77 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 70.5 80 L 71 80.5 L 65.5 86 L 65 85.5 L 70.5 80 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 61.5 90 L 62 90.5 L 58.5 94 L 58 93.5 L 61.5 90 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 450.5 90 L 453 92.5 L 452.5 93 L 450 90.5 L 450.5 90 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 56.5 96 Q 58 97 55.5 98 Q 54 97 56.5 96 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 455.5 96 L 458 98.5 L 457.5 99 L 455 96.5 L 455.5 96 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 53.5 100 L 54 100.5 L 51.5 103 L 51 102.5 L 53.5 100 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 459.5 101 Q 462 102 460.5 103 Q 458 102 459.5 101 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 461.5 104 L 464 106.5 L 463.5 107 L 461 104.5 L 461.5 104 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 49.5 105 L 49.5 106 L 49.5 105 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 47.5 108 Q 49 109 46.5 110 Q 45 109 47.5 108 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 464.5 108 Q 467 109 465.5 110 Q 463 109 464.5 108 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 44.5 112 L 44.5 113 L 44.5 112 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 467.5 112 L 467.5 113 L 467.5 112 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 42.5 115 L 42.5 116 L 42.5 115 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 469.5 115 L 469.5 116 L 469.5 115 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 41.5 117 Q 43 118 40.5 119 Q 39 118 41.5 117 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 471.5 118 L 471.5 119 L 471.5 118 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 39.5 120 Q 41 121 38.5 122 Q 37 121 39.5 120 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 472.5 120 Q 475 121 473.5 122 Q 471 121 472.5 120 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 37.5 123 L 37.5 124 L 37.5 123 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 474.5 123 L 474.5 124 L 474.5 123 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 475.5 125 Q 478 126 476.5 127 Q 474 126 475.5 125 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 35.5 126 L 35.5 127 L 35.5 126 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 34.5 128 L 34.5 129 L 34.5 128 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 477.5 128 L 477.5 129 L 477.5 128 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 33.5 130 L 33.5 131 L 33.5 130 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 478.5 130 L 478.5 131 L 478.5 130 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 31.5 133 L 31.5 134 L 31.5 133 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 480.5 133 L 480.5 134 L 480.5 133 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 30.5 135 L 30.5 136 L 30.5 135 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 481.5 135 L 481.5 136 L 481.5 135 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 29.5 137 L 29.5 138 L 29.5 137 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 482.5 137 L 482.5 138 L 482.5 137 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 28.5 139 L 28.5 140 L 28.5 139 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 483.5 139 L 483.5 140 L 483.5 139 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 27.5 141 L 27.5 142 L 27.5 141 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 484.5 141 L 484.5 142 L 484.5 141 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 26.5 143 L 26.5 144 L 26.5 143 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 80.5 143 L 80.5 144 L 80.5 143 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 362.5 143 L 367 143.5 L 362.5 144 L 362.5 143 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 371.5 143 L 375 143.5 L 371.5 144 L 371.5 143 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 485.5 143 L 485.5 144 L 485.5 143 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 235.5 144 L 287 195.5 L 286.5 196 L 235 144.5 L 235.5 144 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 354.5 144 L 356 144.5 L 354.5 145 L 354.5 144 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 383.5 144 L 383.5 145 L 383.5 144 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 25.5 145 L 25.5 146 L 25.5 145 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 348.5 145 L 350 145.5 L 348.5 146 L 348.5 145 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 388.5 145 L 388.5 146 L 388.5 145 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 486.5 145 L 486.5 146 L 486.5 145 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 79.5 146 L 79.5 147 L 79.5 146 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 345.5 146 L 345.5 147 L 345.5 146 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 392.5 146 L 392.5 147 L 392.5 146 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 24.5 147 L 24.5 148 L 24.5 147 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 341.5 147 L 341.5 148 L 341.5 147 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 395.5 147 L 395.5 148 L 395.5 147 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 487.5 147 L 487.5 148 L 487.5 147 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 338.5 148 L 338.5 149 L 338.5 148 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 398.5 148 L 398.5 149 L 398.5 148 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 23.5 149 L 23.5 150 L 23.5 149 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 78.5 149 L 78.5 150 L 78.5 149 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 335.5 149 L 335.5 150 L 335.5 149 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 401.5 149 L 401.5 150 L 401.5 149 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 488.5 149 L 488.5 150 L 488.5 149 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 403.5 150 L 403.5 151 L 403.5 150 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 22.5 151 L 22.5 152 L 22.5 151 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 489.5 151 L 489.5 152 L 489.5 151 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 77.5 152 L 77.5 153 L 77.5 152 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 328.5 152 L 328.5 153 L 328.5 152 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 21.5 154 L 21.5 155 L 21.5 154 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 411.5 154 L 411.5 155 L 411.5 154 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 490.5 154 L 490.5 155 L 490.5 154 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 76.5 155 L 76.5 156 L 76.5 155 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 413.5 155 L 413.5 156 L 413.5 155 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 20.5 156 L 20.5 157 L 20.5 156 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 491.5 156 L 491.5 157 L 491.5 156 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 416.5 157 L 416.5 158 L 416.5 157 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 19.5 158 L 19.5 159 L 19.5 158 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 75.5 158 L 75.5 159 L 75.5 158 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 419.5 159 L 419.5 160 L 419.5 159 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 492.5 159 L 492.5 160 L 492.5 159 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 315.5 160 L 315.5 161 L 315.5 160 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 18.5 161 L 18.5 162 L 18.5 161 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 74.5 161 L 74.5 162 L 74.5 161 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 493.5 161 L 493.5 162 L 493.5 161 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 423.5 162 Q 426 163 424.5 164 Q 422 163 423.5 162 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 17.5 163 L 18 164.5 L 17 164.5 L 17.5 163 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 494.5 163 L 494.5 164 L 494.5 163 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 73.5 164 L 73.5 165 L 73.5 164 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 16.5 166 L 16.5 167 L 16.5 166 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 495.5 166 L 495.5 167 L 495.5 166 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 72.5 167 L 72.5 168 L 72.5 167 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 15.5 169 L 15.5 170 L 15.5 169 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 496.5 169 L 496.5 170 L 496.5 169 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 71.5 170 L 71.5 171 L 71.5 170 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 433.5 171 L 458 195.5 L 457.5 196 L 440.5 179 L 439 179.5 Q 441.25 178.25 438.5 177 L 436 175.5 L 433 171.5 L 433.5 171 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 14.5 172 L 14.5 173 L 14.5 172 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 497.5 172 L 497.5 173 L 497.5 172 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 70.5 173 L 70.5 174 L 70.5 173 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 227.5 173 L 227.5 174 L 227.5 173 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 13.5 174 L 14 175.5 L 13 175.5 L 13.5 174 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 498.5 175 L 498.5 176 L 498.5 175 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 69.5 176 L 69.5 177 L 69.5 176 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 12.5 178 L 12.5 179 L 12.5 178 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 499.5 178 L 499.5 179 L 499.5 178 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 68.5 179 L 68.5 180 L 68.5 179 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 11.5 181 L 11.5 182 L 11.5 181 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 500.5 181 L 500.5 182 L 500.5 181 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 67.5 182 L 67.5 183 L 67.5 182 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 10.5 184 L 10.5 185 L 10.5 184 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 501.5 184 L 501.5 185 L 501.5 184 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 66.5 185 L 66.5 186 L 66.5 185 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 443.5 185 L 443.5 186 L 443.5 185 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 9.5 188 L 9.5 189 L 9.5 188 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 65.5 188 L 65.5 189 L 65.5 188 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 502.5 188 L 502.5 189 L 502.5 188 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 290.5 189 L 290.5 190 L 290.5 189 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 446.5 190 L 446.5 191 L 446.5 190 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 8.5 191 L 9 192.5 L 8 192.5 L 8.5 191 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 64.5 191 L 64.5 192 L 64.5 191 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 503.5 191 L 504 192.5 L 503 192.5 L 503.5 191 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 447.5 192 L 447.5 193 L 447.5 192 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 288.5 193 L 288.5 194 L 288.5 193 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 63.5 194 L 63.5 195 L 63.5 194 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 7.5 195 L 8 196.5 L 7 196.5 L 7.5 195 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 504.5 195 L 505 196.5 L 504 196.5 L 504.5 195 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 62.5 197 L 62.5 198 L 62.5 197 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 228.5 197 L 228.5 198 L 228.5 197 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 459.5 197 L 510.5 248 L 511 247.5 L 511.5 245 L 512 249.5 L 511.5 250 L 459 197.5 L 459.5 197 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 6.5 199 L 7 200.5 L 6 200.5 L 6.5 199 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 450.5 199 L 450.5 200 L 450.5 199 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 61.5 200 L 61.5 201 L 61.5 200 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 505.5 200 L 505.5 201 L 505.5 200 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 285.5 201 L 285.5 202 L 285.5 201 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 60.5 203 L 60.5 204 L 60.5 203 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 5.5 204 L 6 205.5 L 5 205.5 L 5.5 204 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 506.5 204 L 507 205.5 L 506 205.5 L 506.5 204 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 59.5 206 L 59.5 207 L 59.5 206 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 231.5 206 L 231.5 207 L 231.5 206 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 283.5 208 L 283.5 209 L 283.5 208 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 453.5 208 L 453.5 209 L 453.5 208 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 4.5 209 L 5 210.5 L 4 210.5 L 4.5 209 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 58.5 209 L 58.5 210 L 58.5 209 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 507.5 209 L 508 210.5 L 507 210.5 L 507.5 209 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 232.5 210 L 232.5 211 L 232.5 210 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 57.5 212 L 57.5 213 L 57.5 212 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 310.5 213 L 315.5 214 L 319 216.5 L 321 220.5 L 321 224.5 L 317.5 230 L 313.5 232 L 310.5 232 L 307.5 231 L 304 227.5 Q 302 225 303 219.5 L 306.5 215 L 310.5 213 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 3.5 215 L 4 216.5 L 3 216.5 L 3.5 215 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 56.5 215 L 56.5 216 L 56.5 215 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 233.5 215 L 233.5 216 L 233.5 215 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 508.5 215 L 509 216.5 L 508 216.5 L 508.5 215 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 207.5 216 Q 216.68 215.83 220 221.5 L 222 226.5 L 222 230.5 L 217.5 238 L 214.5 240 Q 210.5 239 209.5 241 Q 208.75 239.25 205.5 240 L 200 236.5 L 198 233.5 L 197 227.5 L 199 221.5 L 202.5 218 L 207.5 216 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 293.5 217 L 293.5 218 L 293.5 217 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 55.5 218 L 56 289 Q 58.67 287.88 58 290.5 L 89.5 322 L 91 322 L 91 368.5 L 233 510.5 L 231 511 L 231 509.5 L 90 368.5 L 90 323.5 L 55 288.5 L 55.5 218 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 281.5 218 L 281.5 219 L 281.5 218 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 455.5 218 L 455.5 219 L 455.5 218 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 2.5 222 L 3 223.5 L 2 223.5 L 2.5 222 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 509.5 222 L 510 223.5 L 509 223.5 L 509.5 222 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 234.5 223 L 234.5 224 L 234.5 223 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 280.5 226 L 280.5 227 L 280.5 226 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 279.5 229 L 279.5 230 L 279.5 229 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1.5 230 L 2 233.5 L 1 233.5 L 1.5 230 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 510.5 231 L 511 233.5 L 510 233.5 L 510.5 231 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 278.5 232 L 278.5 233 L 278.5 232 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 277.5 235 L 277.5 236 L 277.5 235 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 276.5 238 L 276.5 239 L 276.5 238 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 275.5 241 L 275.5 242 L 275.5 241 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 455.5 243 L 455.5 244 L 455.5 243 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 274.5 244 L 274.5 245 L 274.5 244 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 0.5 245 L 1 266.5 L 0 266.5 L 0.5 245 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 273.5 247 L 273.5 248 L 273.5 247 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 272.5 250 L 272.5 251 L 272.5 250 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 271.5 253 L 271.5 254 L 271.5 253 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 270.5 256 L 270.5 257 L 270.5 256 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 269.5 259 L 269.5 260 L 269.5 259 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 268.5 262 L 268.5 263 L 268.5 262 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 267.5 265 L 267.5 266 L 267.5 265 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 266.5 268 L 266.5 269 L 266.5 268 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 443.5 276 L 443.5 277 L 443.5 276 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 1.5 278 L 2 280.5 L 1 280.5 L 1.5 278 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 441.5 279 L 441.5 280 L 441.5 279 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 262.5 280 L 262.5 281 L 262.5 280 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 439.5 282 L 439.5 283 L 439.5 282 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 2.5 287 L 3 289.5 L 2 289.5 L 2.5 287 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 435.5 287 Q 437 288 434.5 289 Q 433 288 435.5 287 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 61.5 290 L 61.5 291 L 61.5 290 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 65.5 291 L 65.5 292 L 65.5 291 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 69.5 292 L 69.5 293 L 69.5 292 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 73.5 293 L 73.5 294 L 73.5 293 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 77.5 294 L 77.5 295 L 77.5 294 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 3.5 295 L 4 296.5 L 3 296.5 L 3.5 295 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 81.5 295 L 81.5 296 L 81.5 295 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 85.5 296 L 85.5 297 L 85.5 296 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 426.5 296 Q 428 297 425.5 298 Q 424 297 426.5 296 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 4.5 301 L 5 302.5 L 4 302.5 L 4.5 301 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 5.5 306 L 6 307.5 L 5 307.5 L 5.5 306 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 6.5 311 L 6.5 312 L 6.5 311 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 7.5 315 L 8 316.5 L 7 316.5 L 7.5 315 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 8.5 319 L 9 320.5 L 8 320.5 L 8.5 319 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 9.5 323 L 9.5 324 L 9.5 323 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 10.5 327 L 10.5 328 L 10.5 327 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 11.5 330 L 11.5 331 L 11.5 330 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 12.5 333 L 12.5 334 L 12.5 333 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 13.5 336 L 13.5 337 L 13.5 336 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 14.5 339 L 14.5 340 L 14.5 339 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 15.5 342 L 15.5 343 L 15.5 342 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 16.5 345 L 16.5 346 L 16.5 345 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 17.5 347 L 17.5 348 L 17.5 347 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 18.5 350 L 18.5 351 L 18.5 350 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 19.5 352 L 19.5 353 L 19.5 352 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 20.5 355 L 20.5 356 L 20.5 355 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 21.5 357 L 21.5 358 L 21.5 357 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 22.5 360 L 22.5 361 L 22.5 360 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 23.5 362 L 23.5 363 L 23.5 362 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 24.5 364 L 24.5 365 L 24.5 364 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 25.5 366 L 25.5 367 L 25.5 366 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 26.5 368 L 26.5 369 L 26.5 368 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 332.5 368 L 360 368.5 L 332.5 369 L 332.5 368 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 424.5 368 L 424.5 369 L 424.5 368 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 27.5 370 L 27.5 371 L 27.5 370 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 28.5 372 L 28.5 373 L 28.5 372 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 29.5 374 L 29.5 375 L 29.5 374 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 30.5 376 L 30.5 377 L 30.5 376 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 31.5 378 L 31.5 379 L 31.5 378 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 33.5 381 L 33.5 382 L 33.5 381 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 34.5 383 L 34.5 384 L 34.5 383 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 35.5 385 Q 38 386 36.5 387 Q 34 386 35.5 385 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 37.5 388 L 37.5 389 L 37.5 388 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 38.5 390 Q 41 391 39.5 392 Q 37 391 38.5 390 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 40.5 393 Q 43 394 41.5 395 Q 39 394 40.5 393 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 42.5 396 L 42.5 397 L 42.5 396 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 44.5 399 L 44.5 400 L 44.5 399 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 46.5 402 Q 49 403 47.5 404 Q 45 403 46.5 402 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 49.5 406 Q 52 407 50.5 408 Q 48 407 49.5 406 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 51.5 409 Q 54 410 52.5 411 Q 50 410 51.5 409 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 54.5 413 L 57 415.5 L 56.5 416 L 54 413.5 L 54.5 413 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 58.5 418 L 62 421.5 L 61.5 422 L 58 418.5 L 58.5 418 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 64.5 425 L 73 433.5 L 72.5 434 L 64 425.5 L 64.5 425 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 78.5 439 L 87 447.5 L 86.5 448 L 78 439.5 L 78.5 439 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 90.5 450 L 93 452.5 L 92.5 453 L 90 450.5 L 90.5 450 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 96.5 455 Q 99 456 97.5 457 Q 95 456 96.5 455 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 100.5 458 L 103 460.5 L 102.5 461 L 100 458.5 L 100.5 458 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 104.5 461 Q 107 462 105.5 463 Q 103 462 104.5 461 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 108.5 464 Q 111 465 109.5 466 Q 107 465 108.5 464 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 112.5 467 L 112.5 468 L 112.5 467 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 115.5 469 L 115.5 470 L 115.5 469 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 117.5 470 Q 120 471 118.5 472 Q 116 471 117.5 470 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 120.5 472 Q 123 473 121.5 474 Q 119 473 120.5 472 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 123.5 474 L 123.5 475 L 123.5 474 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 125.5 475 Q 128 476 126.5 477 Q 124 476 125.5 475 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 128.5 477 L 128.5 478 L 128.5 477 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 130.5 478 L 130.5 479 L 130.5 478 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 133.5 480 L 133.5 481 L 133.5 480 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 135.5 481 L 135.5 482 L 135.5 481 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 137.5 482 L 137.5 483 L 137.5 482 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 139.5 483 L 139.5 484 L 139.5 483 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 141.5 484 L 141.5 485 L 141.5 484 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 143.5 485 L 143.5 486 L 143.5 485 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 145.5 486 L 145.5 487 L 145.5 486 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 147.5 487 L 147.5 488 L 147.5 487 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 149.5 488 L 149.5 489 L 149.5 488 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 151.5 489 L 151.5 490 L 151.5 489 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 154.5 490 L 154.5 491 L 154.5 490 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 156.5 491 L 156.5 492 L 156.5 491 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 159.5 492 L 159.5 493 L 159.5 492 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 161.5 493 L 161.5 494 L 161.5 493 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 164.5 494 L 164.5 495 L 164.5 494 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 166.5 495 L 166.5 496 L 166.5 495 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 169.5 496 L 169.5 497 L 169.5 496 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 172.5 497 L 172.5 498 L 172.5 497 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 175.5 498 L 175.5 499 L 175.5 498 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 178.5 499 L 178.5 500 L 178.5 499 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 181.5 500 L 181.5 501 L 181.5 500 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 184.5 501 L 184.5 502 L 184.5 501 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 188.5 502 L 188.5 503 L 188.5 502 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 192.5 503 L 192.5 504 L 192.5 503 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 195.5 504 L 197 504.5 L 195.5 505 L 195.5 504 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 200.5 505 L 200.5 506 L 200.5 505 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 205.5 506 L 205.5 507 L 205.5 506 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 210.5 507 L 210.5 508 L 210.5 507 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 216.5 508 L 216.5 509 L 216.5 508 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,239)",
    stroke: "rgb(40,100,239)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 222.5 509 L 225 509.5 L 222.5 510 L 222.5 509 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(40,100,240)",
    stroke: "rgb(40,100,240)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 254.5 0 Q 257.75 -0.75 258.5 1 L 278.5 1 L 279.5 2 L 287.5 2 L 288.5 3 L 300.5 4 L 301.5 5 L 305.5 5 L 306.5 6 L 310.5 6 L 311.5 7 L 326.5 10 L 347.5 17 L 350.5 19 L 352.5 19 L 379.5 32 L 397.5 43 L 416.5 57 L 438 76.5 L 455 95.5 L 467 111.5 L 480 132.5 L 490 152.5 L 490 154.5 L 495 164.5 L 502 185.5 L 502 188.5 L 503 189.5 L 503 192.5 L 506 201.5 L 506 205.5 L 508 211.5 L 508 216.5 L 509 217.5 L 509 223.5 L 510 224.5 L 510 233.5 L 511 234.5 L 511 247.5 L 510.5 248 L 459.5 197 Q 457.25 197.75 458 195.5 Q 438.11 172.89 413.5 155 L 401.5 149 L 392.5 146 L 389.5 146 L 388.5 145 Q 384.5 146 383.5 144 L 375.5 144 L 374.5 143 L 362.5 143 L 361.5 144 L 348.5 145 L 344.5 147 L 341.5 147 L 335.5 149 L 330.5 152 L 328.5 152 L 315.5 160 L 301 173.5 Q 292.49 182.99 287.5 196 L 234.5 143 L 80 143 L 80 145.5 L 55 218.5 L 55 288.5 L 90 323.5 L 90 368.5 L 231 509.5 L 225.5 510 L 224.5 509 L 211.5 508 L 210.5 507 L 206.5 507 L 205.5 506 L 201.5 506 L 200.5 505 L 185.5 502 L 167.5 496 L 154.5 490 L 152.5 490 L 132.5 480 L 111.5 467 L 89.5 450 L 73 434.5 L 57 416.5 L 43 397.5 L 42 394.5 L 32 379.5 L 22 359.5 L 22 357.5 L 16 344.5 L 10 326.5 L 10 323.5 L 9 322.5 L 9 319.5 L 6 310.5 L 5 301.5 L 4 300.5 L 4 295.5 L 3 294.5 L 2 278.5 L 1 277.5 L 1 234.5 L 2 233.5 L 2 224.5 L 3 223.5 L 4 211.5 L 5 210.5 L 5 206.5 L 6 205.5 L 6 201.5 L 7 200.5 L 10 185.5 L 16 167.5 L 18 164.5 L 19 159.5 L 22 154.5 L 22 152.5 L 32 132.5 L 45 111.5 L 62 89.5 L 79.5 71 L 95.5 57 L 114.5 43 L 117.5 42 L 132.5 32 L 159.5 19 L 161.5 19 L 164.5 17 L 185.5 10 L 188.5 10 L 189.5 9 L 192.5 9 L 201.5 6 L 205.5 6 L 211.5 4 L 216.5 4 L 217.5 3 L 223.5 3 L 224.5 2 L 232.5 2 L 233.5 1 L 253.5 1 L 254.5 0 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 376.5 144 L 379 144.5 L 376.5 145 L 376.5 144 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 384.5 145 L 384.5 146 L 384.5 145 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 146 L 389.5 147 L 389.5 146 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 393.5 147 L 393.5 148 L 393.5 147 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 148 L 396.5 149 L 396.5 148 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 399.5 149 L 399.5 150 L 399.5 149 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 150 L 401.5 151 L 401.5 150 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 406.5 152 L 406.5 153 L 406.5 152 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 408.5 153 L 408.5 154 L 408.5 153 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 155 L 347.5 156 L 347.5 155 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 156 L 426 168.5 L 425.5 169 L 413 156.5 L 413.5 156 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 159 L 350.5 160 L 350.5 159 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 162 L 352.5 163 L 352.5 162 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 332.5 163 L 332.5 164 L 332.5 163 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 337.5 163 L 337.5 164 L 337.5 163 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 164 L 339.5 165 L 339.5 164 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 165 L 354.5 166 L 354.5 165 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 166 L 327.5 167 L 327.5 166 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 167 L 355.5 168 L 355.5 167 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 343.5 168 L 343.5 169 L 343.5 168 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 169 L 399 169.5 L 379.5 189 L 379 188.5 L 398.5 169 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 170 L 325.5 171 L 325.5 170 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 171 L 344.5 172 L 344.5 171 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 174 L 345 175.5 L 344 175.5 L 344.5 174 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 175 L 325.5 176 L 325.5 175 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 343.5 177 L 343.5 178 L 343.5 177 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 179 Q 330 180 328.5 181 Q 326 180 327.5 179 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 179 L 361.5 180 L 361.5 179 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 181 L 339.5 182 L 339.5 181 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 332.5 182 L 332.5 183 L 332.5 182 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 337.5 182 L 337.5 183 L 337.5 182 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 190 L 365.5 191 L 365.5 190 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 406.5 190 L 455 238.5 L 454.5 239 L 406 190.5 L 406.5 190 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 201 L 368.5 202 L 368.5 201 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 203 L 285.5 204 L 285.5 203 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 203 L 306.5 204 L 306.5 203 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 210 L 327.5 211 L 327.5 210 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 211 L 295.5 212 L 295.5 211 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 216 L 282.5 217 L 282.5 216 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 218 L 292.5 219 L 292.5 218 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 219 L 371.5 220 L 371.5 219 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 220 L 332 221.5 L 331 221.5 L 331.5 220 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 222 L 349.5 223 L 349.5 222 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 223 L 332 224.5 L 331 224.5 L 331.5 223 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 223 L 348 223.5 L 345.5 226 L 345 225.5 L 347.5 223 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 224 L 281.5 225 L 281.5 224 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 226 L 292.5 227 L 292.5 226 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 227 L 344.5 228 L 344.5 227 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 228 L 280.5 229 L 280.5 228 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 343.5 230 L 344 232.5 L 343 232.5 L 343.5 230 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 231 L 279.5 232 L 279.5 231 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 234 L 278.5 235 L 278.5 234 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 234 L 327.5 235 L 327.5 234 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 237 L 277.5 238 L 277.5 237 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 237 L 348 239.5 L 347.5 240 L 345 237.5 L 345.5 237 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 323.5 238 L 323.5 239 L 323.5 238 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 276.5 240 L 276.5 241 L 276.5 240 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 240 L 303.5 241 L 303.5 240 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 240 L 349.5 241 L 349.5 240 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 241 L 306.5 242 L 306.5 241 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317.5 241 L 317.5 242 L 317.5 241 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 243 L 275.5 244 L 275.5 243 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 454.5 245 L 454.5 246 L 454.5 245 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 246 L 274.5 247 L 274.5 246 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 249 L 273.5 250 L 273.5 249 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 453.5 250 L 453.5 251 L 453.5 250 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 252 L 272.5 253 L 272.5 252 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 452.5 254 L 452.5 255 L 452.5 254 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 255 L 271.5 256 L 271.5 255 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 451.5 257 L 451.5 258 L 451.5 257 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 450.5 260 L 450.5 261 L 450.5 260 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 272 L 397 294.5 L 396 294.5 L 396.5 272 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 400.5 273 L 400.5 274 L 400.5 273 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 341.5 277 L 341.5 278 L 341.5 277 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 277 L 347.5 278 L 347.5 277 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 278 L 339.5 279 L 339.5 278 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 278 L 349.5 279 L 349.5 278 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 268.5 280 L 284 280.5 L 268.5 281 L 268.5 280 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 281 L 336.5 282 L 336.5 281 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 283 L 335.5 284 L 335.5 283 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 287 L 354.5 288 L 354.5 287 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 290 L 335.5 291 L 335.5 290 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 292 L 339 294.5 L 338.5 295 L 336 292.5 L 336.5 292 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 292 L 352.5 293 L 352.5 292 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 292 L 362.5 293 L 362.5 292 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 295 L 349.5 296 L 349.5 295 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 296 L 344 296.5 L 342.5 297 L 342.5 296 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 296 L 347 296.5 L 345.5 297 L 345.5 296 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 301 L 358.5 302 L 358.5 301 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 357.5 303 L 357.5 304 L 357.5 303 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 305 L 300.5 306 L 300.5 305 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 305 L 306.5 306 L 306.5 305 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 307 L 312 309.5 L 311.5 310 L 309 307.5 L 309.5 307 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 310 L 294.5 311 L 294.5 310 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 310 L 353.5 311 L 353.5 310 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 311 L 312.5 312 L 312.5 311 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 313 L 294 316.5 L 293 316.5 L 293.5 313 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 313 L 351.5 314 L 351.5 313 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 313 L 415 313.5 L 387 314 L 386.5 368 L 386 314.5 L 387.5 313 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 349.5 316 L 349.5 317 L 349.5 316 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 317 L 312.5 318 L 312.5 317 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 319 L 294.5 320 L 294.5 319 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 310.5 321 L 310.5 322 L 310.5 321 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 321 L 346 321.5 L 343.5 324 L 343 323.5 L 345.5 321 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 323 L 298.5 324 L 298.5 323 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 323 L 307.5 324 L 307.5 323 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 301.5 324 L 303 324.5 L 301.5 325 L 301.5 324 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 304.5 324 L 306 324.5 L 304.5 325 L 304.5 324 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 328 Q 340 329 337.5 330 Q 336 329 338.5 328 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(223,223,230)",
    stroke: "rgb(223,223,230)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 332 L 333.5 333 L 333.5 332 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 146 L 80.5 147 L 80.5 146 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 149 L 79.5 150 L 79.5 149 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 152 L 78.5 153 L 78.5 152 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 155 L 77.5 156 L 77.5 155 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 156 L 231.5 157 L 231.5 156 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 158 L 76.5 159 L 76.5 158 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 160 L 230.5 161 L 230.5 160 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 161 L 75.5 162 L 75.5 161 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 164 L 74.5 165 L 74.5 164 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 167 L 73.5 168 L 73.5 167 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 170 L 72.5 171 L 72.5 170 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 187 L 66.5 188 L 66.5 187 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 187 L 220.5 188 L 220.5 187 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 190 L 65.5 191 L 65.5 190 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 190 L 218.5 191 L 218.5 190 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 193 L 64.5 194 L 64.5 193 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 193 L 217 193.5 L 213.5 197 L 213 196.5 L 216.5 193 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 196 L 63.5 197 L 63.5 196 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 199 L 62.5 200 L 62.5 199 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 209.5 200 L 210 200.5 L 206.5 204 L 206 203.5 L 209.5 200 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 202 L 61.5 203 L 61.5 202 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 205 L 60.5 206 L 60.5 205 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 205 Q 205 206 202.5 207 Q 201 206 203.5 205 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 207 L 200.5 208 L 200.5 207 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 208 L 59.5 209 L 59.5 208 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 209 L 197.5 210 L 197.5 209 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 195.5 210 L 195.5 211 L 195.5 210 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 211 L 58.5 212 L 58.5 211 Z "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 211 L 193.5 212 L 193.5 211 Z "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 212 L 191.5 213 L 191.5 212 Z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 213 L 188.5 214 L 188.5 213 Z "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 214 L 57.5 215 L 57.5 214 Z "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 214 L 186.5 215 L 186.5 214 Z "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 182.5 215 L 184 215.5 L 182.5 216 L 182.5 215 Z "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 216 L 180 216.5 L 178.5 217 L 178.5 216 Z "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 217 L 56.5 218 L 56.5 217 Z "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 217 L 175 317.5 L 172.5 319 L 172.5 318 L 174 317.5 L 174.5 217 Z "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 288 L 56.5 289 L 56.5 288 Z "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 289 L 60.5 290 L 60.5 289 Z "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 294 L 79.5 295 L 79.5 294 Z "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 295 L 83.5 296 L 83.5 295 Z "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 296 L 87.5 297 L 87.5 296 Z "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 313 L 154.5 314 L 154.5 313 Z "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 314 L 158 314.5 L 156.5 315 L 156.5 314 Z "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 315 L 162 315.5 L 160.5 316 L 160.5 315 Z "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 316 L 166 316.5 L 164.5 317 L 164.5 316 Z "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,154,52)",
    stroke: "rgb(239,154,52)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 317 L 170 317.5 L 168.5 318 L 168.5 317 Z "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(218,125,0)",
    stroke: "rgb(218,125,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154 144 L 233.5 144 Q 234.38 143.88 234 147.5 L 233 148.5 L 233 151.5 L 230 160.5 L 230 164.5 L 229 165.5 L 229 168.5 L 226 177.5 Q 220.25 190.75 210.5 200 Q 202.07 208.07 190.5 213 L 188.5 213 L 185.5 215 L 178.5 216 L 177.5 217 L 174 217 L 174 317.5 Q 174.13 318.38 170.5 318 L 169.5 317 L 158.5 315 L 154 312.5 L 154 144 Z "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 143 L 233.5 143 L 235 144.5 L 234.5 146 L 234 144 L 155.5 144 L 155.5 143 Z "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 145 L 80.5 146 L 80.5 145 Z "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 148 L 79.5 149 L 79.5 148 Z "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 148 L 234 149.5 L 233 149.5 L 233.5 148 Z "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 151 L 78.5 152 L 78.5 151 Z "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 152 L 233 153.5 L 232 153.5 L 232.5 152 Z "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 154 L 77.5 155 L 77.5 154 Z "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 157 L 76.5 158 L 76.5 157 Z "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 157 L 231.5 158 L 231.5 157 Z "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 160 L 75.5 161 L 75.5 160 Z "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 161 L 230.5 162 L 230.5 161 Z "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 163 L 74.5 164 L 74.5 163 Z "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 165 L 229.5 166 L 229.5 165 Z "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 166 L 73.5 167 L 73.5 166 Z "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 169 L 72.5 170 L 72.5 169 Z "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 169 L 228.5 170 L 228.5 169 Z "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 172 L 71.5 173 L 71.5 172 Z "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 172 L 227.5 173 L 227.5 172 Z "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 175 L 70.5 176 L 70.5 175 Z "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 175 L 226.5 176 L 226.5 175 Z "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 178 L 69.5 179 L 69.5 178 Z "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 178 L 225.5 179 L 225.5 178 Z "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 180 L 224.5 181 L 224.5 180 Z "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 181 L 68.5 182 L 68.5 181 Z "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 182 L 223.5 183 L 223.5 182 Z "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 184 L 67.5 185 L 67.5 184 Z "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 184 L 222.5 185 L 222.5 184 Z "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 310.5 203 L 314 203.5 L 310.5 204 L 310.5 203 Z "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 204 L 60.5 205 L 60.5 204 Z "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 305.5 204 L 305.5 205 L 305.5 204 Z "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 205 L 320.5 206 L 320.5 205 Z "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 301.5 206 L 301.5 207 L 301.5 206 Z "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 207 L 59.5 208 L 59.5 207 Z "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 323.5 207 L 323.5 208 L 323.5 207 Z "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 210 L 58.5 211 L 58.5 210 Z "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 211 L 327.5 212 L 327.5 211 Z "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 212 L 295.5 213 L 295.5 212 Z "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 213 L 57.5 214 L 57.5 213 Z "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 214 L 294.5 215 L 294.5 214 Z "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 215 L 329.5 216 L 329.5 215 Z "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 216 L 56.5 217 L 56.5 216 Z "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 218 L 330.5 219 L 330.5 218 Z "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 226 L 330.5 227 L 330.5 226 Z "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 230 L 294.5 231 L 294.5 230 Z "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 232 L 295.5 233 L 295.5 232 Z "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 233 L 327.5 234 L 327.5 233 Z "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 400.5 234 L 400.5 235 L 400.5 234 Z "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 411.5 234 L 411.5 235 L 411.5 234 Z "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 237 L 394.5 238 L 394.5 237 Z "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 417.5 237 L 417.5 238 L 417.5 237 Z "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 239 L 320.5 240 L 320.5 239 Z "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 305.5 240 L 305.5 241 L 305.5 240 Z "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 240 L 318.5 241 L 318.5 240 Z "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 241 L 311 241.5 L 309.5 242 L 309.5 241 Z "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 313.5 241 L 315 241.5 L 313.5 242 L 313.5 241 Z "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 242 L 389.5 243 L 389.5 242 Z "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 422.5 242 L 422.5 243 L 422.5 242 Z "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 246 L 387.5 247 L 387.5 246 Z "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 424.5 246 L 424.5 247 L 424.5 246 Z "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 249 L 386.5 250 L 386.5 249 Z "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 425.5 249 L 425.5 250 L 425.5 249 Z "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 425.5 257 L 426 258.5 L 425 258.5 L 425.5 257 Z "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 258 L 386.5 259 L 386.5 258 Z "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 261 L 387.5 262 L 387.5 261 Z "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 424.5 261 L 424.5 262 L 424.5 261 Z "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 263 L 388.5 264 L 388.5 263 Z "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 423.5 263 L 423.5 264 L 423.5 263 Z "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 266 L 393 268.5 L 392.5 269 L 390 266.5 L 390.5 266 Z "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 420.5 267 Q 422 268 419.5 269 Q 418 268 420.5 267 Z "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 399.5 272 L 399.5 273 L 399.5 272 Z "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 412.5 272 L 412.5 273 L 412.5 272 Z "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 403.5 273 L 409 273.5 L 403.5 274 L 403.5 273 Z "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 289 L 60 289.5 L 58.5 290 L 58.5 289 Z "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 290 L 64 290.5 L 62.5 291 L 62.5 290 Z "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 291 L 68 291.5 L 66.5 292 L 66.5 291 Z "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 292 L 72 292.5 L 70.5 293 L 70.5 292 Z "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 293 L 76 293.5 L 74.5 294 L 74.5 293 Z "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 294 L 78.5 295 L 78.5 294 Z "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 295 L 82.5 296 L 82.5 295 Z "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 296 L 86.5 297 L 86.5 296 Z "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(143,122,117)",
    stroke: "rgb(143,122,117)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 297 L 91 297.5 L 89.5 298 L 89.5 297 Z "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(226,228,247)",
    stroke: "rgb(226,228,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 148 L 347 154.5 L 357 169.5 L 365 187.5 L 365 190.5 L 368 197.5 L 368 201.5 L 369 202.5 L 370 211.5 L 371 212.5 L 371 219.5 L 372 220.5 L 372 254.5 L 371 255.5 L 371 262.5 L 370 263.5 L 369 272.5 L 368 273.5 L 367 280.5 L 364 289.5 L 362 292.5 L 362 294.5 L 355 308.5 L 349 317.5 L 339.5 328 L 331.5 334 L 285 334 L 285 281.5 L 283.5 280 L 268.5 280 L 267.5 281 L 263 281 L 281 228.5 Q 280.25 225.25 282 224.5 L 282 217.5 L 283 216.5 L 283 211.5 L 284 210.5 L 284 207.5 L 288 195.5 Q 296.69 175.69 312.5 163 L 322.5 156 L 340.5 148 Z M 333 163 L 329 166 L 327 166 L 325 171 L 325 176 L 327 180 L 333 183 Q 337 184 340 182 L 345 176 L 344 169 L 338 163 L 333 163 Z M 307 203 L 301 206 L 295 212 L 292 219 L 292 227 L 295 234 Q 299 239 307 242 L 318 242 L 324 239 L 328 235 L 332 225 L 331 217 L 328 211 L 320 204 L 317 203 L 307 203 Z M 350 222 L 348 223 L 345 226 L 343 231 L 345 238 L 350 241 Q 356 242 359 240 L 363 235 Q 364 229 362 227 L 357 222 L 350 222 Z M 342 277 L 340 278 L 335 284 Q 334 290 336 293 L 343 297 L 350 296 L 353 293 L 355 288 L 353 282 L 348 277 L 342 277 Z M 301 305 L 299 306 L 294 311 L 293 314 L 294 320 L 299 324 L 302 325 L 306 325 L 310 322 L 311 322 L 313 318 Q 314 312 312 310 L 307 305 L 301 305 Z "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 143 L 155 143.5 L 81.5 144 L 80.5 145 Q 79 144 81.5 143 Z "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 143 L 234.5 144 L 234.5 143 Z "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 147 L 79.5 148 L 79.5 147 Z "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 150 L 78.5 151 L 78.5 150 Z "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 153 L 77.5 154 L 77.5 153 Z "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 156 L 76.5 157 L 76.5 156 Z "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 159 L 75.5 160 L 75.5 159 Z "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 162 L 74.5 163 L 74.5 162 Z "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 165 L 73.5 166 L 73.5 165 Z "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 168 L 72.5 169 L 72.5 168 Z "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 171 L 71.5 172 L 71.5 171 Z "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 434.5 173 Q 437 174 435.5 175 Q 433 174 434.5 173 Z "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 174 L 70.5 175 L 70.5 174 Z "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 177 L 69.5 178 L 69.5 177 Z "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 438.5 178 L 438.5 179 L 438.5 178 Z "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 180 L 68.5 181 L 68.5 180 Z "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 441.5 182 L 441.5 183 L 441.5 182 Z "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 183 L 67.5 184 L 67.5 183 Z "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 222.5 185 L 222.5 186 L 222.5 185 Z "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 186 L 66.5 187 L 66.5 186 Z "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 444.5 187 L 444.5 188 L 444.5 187 Z "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 189 L 65.5 190 L 65.5 189 Z "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 192 L 64.5 193 L 64.5 192 Z "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 195 L 63.5 196 L 63.5 195 Z "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 227.5 195 L 227.5 196 L 227.5 195 Z "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 449.5 197 L 449.5 198 L 449.5 197 Z "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 198 L 62.5 199 L 62.5 198 Z "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 200 L 229.5 201 L 229.5 200 Z "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 201 L 61.5 202 L 61.5 201 Z "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 451.5 202 L 451.5 203 L 451.5 202 Z "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 203 L 230.5 204 L 230.5 203 Z "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 203 L 310 203.5 L 308.5 204 L 308.5 203 Z "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 203 L 316 203.5 L 314.5 204 L 314.5 203 Z "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 204 L 318.5 205 L 318.5 204 Z "
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 452.5 205 L 452.5 206 L 452.5 205 Z "
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322.5 206 L 322.5 207 L 322.5 206 Z "
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 208 L 298.5 209 L 298.5 208 Z "
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 453.5 209 L 453.5 210 L 453.5 209 Z "
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 211 L 232.5 212 L 232.5 211 Z "
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 213 L 282.5 214 L 282.5 213 Z "
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 213 L 309.5 214 L 309.5 213 Z "
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 313.5 213 L 313.5 214 L 313.5 213 Z "
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 454.5 213 L 454.5 214 L 454.5 213 Z "
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 214 L 307.5 215 L 307.5 214 Z "
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 214 L 316.5 215 L 316.5 214 Z "
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 216 L 233.5 217 L 233.5 216 Z "
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 216 L 293.5 217 L 293.5 216 Z "
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 217 L 319.5 218 L 319.5 217 Z "
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 217 L 330.5 218 L 330.5 217 Z "
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 218 L 303.5 219 L 303.5 218 Z "
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 219 L 281.5 220 L 281.5 219 Z "
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 219 L 320.5 220 L 320.5 219 Z "
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 455.5 219 L 456 220.5 L 455 220.5 L 455.5 219 Z "
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 221 L 293 223.5 L 292 223.5 L 292.5 221 Z "
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 221 L 303 223.5 L 302 223.5 L 302.5 221 Z "
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 224 L 235 225.5 L 234 225.5 L 234.5 224 Z "
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 225 L 320.5 226 L 320.5 225 Z "
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 226 L 303.5 227 L 303.5 226 Z "
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 227 L 319.5 228 L 319.5 227 Z "
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 227 L 330.5 228 L 330.5 227 Z "
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 228 L 235.5 229 L 235.5 228 Z "
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 228 L 293.5 229 L 293.5 228 Z "
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 304.5 228 Q 307 229 305.5 230 Q 303 229 304.5 228 Z "
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 230 L 316.5 231 L 316.5 230 Z "
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 230 L 329.5 231 L 329.5 230 Z "
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 231 L 236.5 232 L 236.5 231 Z "
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 309.5 231 L 309.5 232 L 309.5 231 Z "
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 231 L 314.5 232 L 314.5 231 Z "
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 404.5 233 L 408 233.5 L 404.5 234 L 404.5 233 Z "
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 234 L 237.5 235 L 237.5 234 Z "
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 399.5 234 L 399.5 235 L 399.5 234 Z "
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 412.5 234 L 412.5 235 L 412.5 234 Z "
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 235 Q 300 236 298.5 237 Q 296 236 297.5 235 Z "
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 397.5 235 L 397.5 236 L 397.5 235 Z "
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 414.5 235 L 414.5 236 L 414.5 235 Z "
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 395.5 236 L 395.5 237 L 395.5 236 Z "
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 416.5 236 L 416.5 237 L 416.5 236 Z "
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 237 L 238.5 238 L 238.5 237 Z "
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 322.5 238 L 322.5 239 L 322.5 238 Z "
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 239 L 302.5 240 L 302.5 239 Z "
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 239 L 391.5 240 L 391.5 239 Z "
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 420.5 239 L 420.5 240 L 420.5 239 Z "
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 240 L 239.5 241 L 239.5 240 Z "
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 304.5 240 L 304.5 241 L 304.5 240 Z "
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 241 L 308.5 242 L 308.5 241 Z "
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 241 L 315.5 242 L 315.5 241 Z "
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 243 L 240.5 244 L 240.5 243 Z "
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 388.5 243 L 388.5 244 L 388.5 243 Z "
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 423.5 243 L 423.5 244 L 423.5 243 Z "
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 245 L 387.5 246 L 387.5 245 Z "
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 424.5 245 L 424.5 246 L 424.5 245 Z "
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 241.5 246 L 241.5 247 L 241.5 246 Z "
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 248 L 386.5 249 L 386.5 248 Z "
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 425.5 248 L 425.5 249 L 425.5 248 Z "
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 454.5 248 L 454.5 249 L 454.5 248 Z "
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 242.5 249 L 242.5 250 L 242.5 249 Z "
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 243.5 252 L 243.5 253 L 243.5 252 Z "
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 244.5 255 L 244.5 256 L 244.5 255 Z "
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 452.5 256 L 452.5 257 L 452.5 256 Z "
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 245.5 258 L 245.5 259 L 245.5 258 Z "
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 259 L 386.5 260 L 386.5 259 Z "
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 425.5 259 L 425.5 260 L 425.5 259 Z "
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 451.5 259 L 451.5 260 L 451.5 259 Z "
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 246.5 261 L 246.5 262 L 246.5 261 Z "
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 247.5 264 L 247.5 265 L 247.5 264 Z "
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 449.5 264 L 449.5 265 L 449.5 264 Z "
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 389.5 265 L 389.5 266 L 389.5 265 Z "
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 422.5 265 Q 424 266 421.5 267 Q 420 266 422.5 265 Z "
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 448.5 266 L 448.5 267 L 448.5 266 Z "
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 248.5 267 L 248.5 268 L 248.5 267 Z "
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 393.5 269 Q 396 270 394.5 271 Q 392 270 393.5 269 Z "
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 418.5 269 Q 420 270 417.5 271 Q 416 270 418.5 269 Z "
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 249.5 270 L 249.5 271 L 249.5 270 Z "
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 446.5 270 L 446.5 271 L 446.5 270 Z "
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 271 L 265.5 272 L 265.5 271 Z "
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 396.5 271 L 396.5 272 L 396.5 271 Z "
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 415.5 271 L 415.5 272 L 415.5 271 Z "
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 445.5 272 L 445.5 273 L 445.5 272 Z "
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 250.5 273 L 250.5 274 L 250.5 273 Z "
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 402.5 273 L 402.5 274 L 402.5 273 Z "
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 409.5 273 L 409.5 274 L 409.5 273 Z "
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 274 L 264.5 275 L 264.5 274 Z "
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 444.5 274 L 444.5 275 L 444.5 274 Z "
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 263.5 277 L 263.5 278 L 263.5 277 Z "
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 442.5 277 L 442.5 278 L 442.5 277 Z "
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 438.5 283 L 438.5 284 L 438.5 283 Z "
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 433.5 289 L 434 289.5 L 427.5 296 L 427 295.5 L 433.5 289 Z "
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 368 L 184 368.5 L 91.5 369 L 91.5 368 Z "
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 368 L 368 368.5 L 360.5 369 L 360.5 368 Z "
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(123,140,183)",
    stroke: "rgb(123,140,183)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 368 L 424 368.5 L 387.5 369 L 387.5 368 Z "
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367.5 143 L 371 143.5 L 367.5 144 L 367.5 143 Z "
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 144 L 359 144.5 L 356.5 145 L 356.5 144 Z "
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 382.5 144 L 382.5 145 L 382.5 144 Z "
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 145 L 352 145.5 L 350.5 146 L 350.5 145 Z "
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 387.5 145 L 387.5 146 L 387.5 145 Z "
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 346.5 146 L 346.5 147 L 346.5 146 Z "
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 391.5 146 L 391.5 147 L 391.5 146 Z "
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 147 L 344 147.5 L 342.5 148 L 342.5 147 Z "
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 400.5 149 L 400.5 150 L 400.5 149 Z "
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 150 L 333.5 151 L 333.5 150 Z "
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 405.5 151 L 405.5 152 L 405.5 151 Z "
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 407.5 152 L 407.5 153 L 407.5 152 Z "
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 409.5 153 L 409.5 154 L 409.5 153 Z "
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 323.5 155 L 323.5 156 L 323.5 155 Z "
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 414.5 156 L 414.5 157 L 414.5 156 Z "
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 158 L 318.5 159 L 318.5 158 Z "
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 417.5 158 L 417.5 159 L 417.5 158 Z "
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 420.5 160 Q 423 161 421.5 162 Q 419 161 420.5 160 Z "
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 310.5 164 Q 312 165 309.5 166 Q 308 165 310.5 164 Z "
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 425.5 164 L 434 172.5 L 433.5 173 L 425 164.5 L 425.5 164 Z "
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 172 Q 304 173 301.5 174 Q 300 173 302.5 172 Z "
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 437.5 177 L 437.5 178 L 437.5 177 Z "
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 178 L 297.5 179 L 297.5 178 Z "
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 181 L 295.5 182 L 295.5 181 Z "
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 440.5 181 L 440.5 182 L 440.5 181 Z "
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 184 L 293.5 185 L 293.5 184 Z "
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 442.5 184 L 442.5 185 L 442.5 184 Z "
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 445.5 189 L 445.5 190 L 445.5 189 Z "
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 446.5 191 L 446.5 192 L 446.5 191 Z "
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 447.5 193 L 447.5 194 L 447.5 193 Z "
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 288.5 194 L 288.5 195 L 288.5 194 Z "
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 448.5 195 L 448.5 196 L 448.5 195 Z "
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 196 L 287.5 197 L 287.5 196 Z "
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 199 L 286.5 200 L 286.5 199 Z "
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 450.5 200 L 450.5 201 L 450.5 200 Z "
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 285.5 202 L 285.5 203 L 285.5 202 Z "
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 451.5 203 L 451.5 204 L 451.5 203 Z "
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284.5 205 L 284.5 206 L 284.5 205 Z "
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 452.5 206 L 452.5 207 L 452.5 206 Z "
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 231.5 207 L 231.5 208 L 231.5 207 Z "
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 209 L 283.5 210 L 283.5 209 Z "
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 297.5 209 L 297.5 210 L 297.5 209 Z "
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 453.5 210 L 453.5 211 L 453.5 210 Z "
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 214 L 282.5 215 L 282.5 214 Z "
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 454.5 214 L 455 215.5 L 454 215.5 L 454.5 214 Z "
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 216 L 206.5 217 L 206.5 216 Z "
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 212.5 216 L 212.5 217 L 212.5 216 Z "
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 217 L 203.5 218 L 203.5 217 Z "
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 217 L 215.5 218 L 215.5 217 Z "
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 220 L 281.5 221 L 281.5 220 Z "
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 220 L 292.5 221 L 292.5 220 Z "
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 455.5 221 L 456 222.5 L 455 222.5 L 455.5 221 Z "
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 222 L 220.5 223 L 220.5 222 Z "
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 224 L 292.5 225 L 292.5 224 Z "
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 225 L 198 226.5 L 197 226.5 L 197.5 225 Z "
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 225 L 221.5 226 L 221.5 225 Z "
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 280.5 227 L 280.5 228 L 280.5 227 Z "
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 230 L 198 231.5 L 197 231.5 L 197.5 230 Z "
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 279.5 230 L 279.5 231 L 279.5 230 Z "
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 231 L 221.5 232 L 221.5 231 Z "
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 235 L 199.5 236 L 199.5 235 Z "
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 235 L 219.5 236 L 219.5 235 Z "
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 299.5 237 L 299.5 238 L 299.5 237 Z "
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 238 L 202.5 239 L 202.5 238 Z "
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 216.5 238 L 216.5 239 L 216.5 238 Z "
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 238 L 392.5 239 L 392.5 238 Z "
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 419.5 238 L 419.5 239 L 419.5 238 Z "
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 239 L 204.5 240 L 204.5 239 Z "
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 206.5 240 L 209 240.5 L 206.5 241 L 206.5 240 Z "
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 210.5 240 L 213 240.5 L 210.5 241 L 210.5 240 Z "
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 240 L 390.5 241 L 390.5 240 Z "
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 421.5 240 L 421.5 241 L 421.5 240 Z "
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 455.5 242 L 455.5 243 L 455.5 242 Z "
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 453.5 252 L 453.5 253 L 453.5 252 Z "
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 450.5 261 L 450.5 262 L 450.5 261 Z "
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 447.5 268 L 447.5 269 L 447.5 268 Z "
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 251.5 276 L 251.5 277 L 251.5 276 Z "
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 279 L 252.5 280 L 252.5 279 Z "
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 440.5 280 L 440.5 281 L 440.5 280 Z "
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 437.5 284 L 437.5 285 L 437.5 284 Z "
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 424.5 298 L 425 337.5 L 424 337.5 L 424.5 298 Z "
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(135,157,213)",
    stroke: "rgb(135,157,213)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 368 L 387 368.5 L 368.5 369 L 368.5 368 Z "
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,158,39)",
    stroke: "rgb(253,158,39)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81 144 L 154 144 L 154 313 L 150.5 313 L 149.5 312 L 146.5 312 L 144 311 L 144 272.5 L 141 264.5 L 135.5 259 L 128.5 256 L 119.5 256 L 113.5 259 L 108 264.5 L 105 271.5 L 105 301 L 98.5 300 L 97.5 299 L 94.5 299 L 87.5 296 L 84.5 296 L 83.5 295 L 80.5 295 L 79.5 294 L 64.5 291 L 60.5 289 L 57.5 289 L 56 287.5 L 56 218.5 L 71 173.5 L 73 170.5 L 81 146.5 L 81 144 Z "
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(236,196,188)",
    stroke: "rgb(236,196,188)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221 186 Q 223.67 184.88 223 187.5 L 228 196.5 L 232 208.5 L 233 218.5 L 234 219.5 L 234 226.5 L 252 277.5 L 252 281 L 231 281 L 231 334 L 184 334 L 184 368 L 154 368 L 154 314.5 L 155.5 314 L 156.5 315 L 159.5 315 L 160.5 316 L 163.5 316 L 164.5 317 L 167.5 317 L 173.5 319 L 175 317.5 L 175 217 L 183.5 216 L 197.5 210 L 206.5 204 L 217 193.5 L 221 187.5 L 221 186 Z M 206 216 L 202 218 L 197 225 Q 196 231 198 235 L 206 241 L 214 241 L 218 238 L 219 238 L 219 237 L 222 233 L 222 225 L 220 221 L 214 216 L 206 216 Z "
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 144 L 381.5 145 L 381.5 144 Z "
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 145 L 352.5 146 L 352.5 145 Z "
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 394.5 147 L 394.5 148 L 394.5 147 Z "
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 339.5 148 L 339.5 149 L 339.5 148 Z "
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 397.5 148 L 397.5 149 L 397.5 148 Z "
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 149 L 336.5 150 L 336.5 149 Z "
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 151 L 331.5 152 L 331.5 151 Z "
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 152 L 329.5 153 L 329.5 152 Z "
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 327.5 153 L 327.5 154 L 327.5 153 Z "
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 154 L 325.5 155 L 325.5 154 Z "
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 157 L 320.5 158 L 320.5 157 Z "
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 161 L 314.5 162 L 314.5 161 Z "
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 166 L 309 166.5 L 303.5 172 L 303 171.5 L 308.5 166 Z "
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 177 L 298.5 178 L 298.5 177 Z "
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 186 L 292.5 187 L 292.5 186 Z "
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 291.5 188 L 291.5 189 L 291.5 188 Z "
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 290.5 190 L 290.5 191 L 290.5 190 Z "
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 289.5 192 L 289.5 193 L 289.5 192 Z "
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 210 L 296.5 211 L 296.5 210 Z "
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 221 L 282 222.5 L 281 222.5 L 281.5 221 Z "
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 225 L 292.5 226 L 292.5 225 Z "
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 278.5 233 L 278.5 234 L 278.5 233 Z "
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 277.5 236 L 277.5 237 L 277.5 236 Z "
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 276.5 239 L 276.5 240 L 276.5 239 Z "
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 240 L 319.5 241 L 319.5 240 Z "
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 241 L 316.5 242 L 316.5 241 Z "
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 275.5 242 L 275.5 243 L 275.5 242 Z "
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 274.5 245 L 274.5 246 L 274.5 245 Z "
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 454.5 247 L 454.5 248 L 454.5 247 Z "
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 273.5 248 L 273.5 249 L 273.5 248 Z "
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 272.5 251 L 272.5 252 L 272.5 251 Z "
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 271.5 254 L 271.5 255 L 271.5 254 Z "
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 270.5 257 L 270.5 258 L 270.5 257 Z "
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 269.5 260 L 269.5 261 L 269.5 260 Z "
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 268.5 263 L 268.5 264 L 268.5 263 Z "
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 267.5 266 L 267.5 267 L 267.5 266 Z "
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 266.5 269 L 266.5 270 L 266.5 269 Z "
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 265.5 272 L 265.5 273 L 265.5 272 Z "
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 264.5 275 L 264.5 276 L 264.5 275 Z "
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 263.5 278 L 263.5 279 L 263.5 278 Z "
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(166,186,229)",
    stroke: "rgb(166,186,229)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284.5 281 L 285 333.5 L 284 333.5 L 284.5 281 Z "
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 374.5 144 L 399 168.5 L 398.5 169 L 374 144.5 L 374.5 144 Z "
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 379.5 144 L 379.5 145 L 379.5 144 Z "
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 385.5 145 L 385.5 146 L 385.5 145 Z "
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 146 L 390.5 147 L 390.5 146 Z "
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 341.5 148 L 347 153.5 L 346.5 154 L 341 148.5 L 341.5 148 Z "
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 334.5 150 L 334.5 151 L 334.5 150 Z "
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 402.5 150 L 402.5 151 L 402.5 150 Z "
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 404.5 151 L 404.5 152 L 404.5 151 Z "
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 410.5 154 L 410.5 155 L 410.5 154 Z "
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 412.5 155 L 412.5 156 L 412.5 155 Z "
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 156 Q 351 157 349.5 158 Q 347 157 348.5 156 Z "
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 160 L 351.5 161 L 351.5 160 Z "
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 313.5 162 L 313.5 163 L 313.5 162 Z "
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 163 L 337 163.5 L 333.5 164 L 333.5 163 Z "
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 163 L 353.5 164 L 353.5 163 Z "
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 164 Q 332 165 329.5 166 Q 328 165 330.5 164 Z "
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 165 L 340.5 166 L 340.5 165 Z "
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 166 L 355.5 167 L 355.5 166 Z "
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 167 L 342.5 168 L 342.5 167 Z "
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 326.5 168 L 326.5 169 L 326.5 168 Z "
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 168 L 356.5 169 L 356.5 168 Z "
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 425.5 169 L 426 169.5 L 406.5 189 L 406 188.5 L 425.5 169 Z "
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 357.5 170 L 357.5 171 L 357.5 170 Z "
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 171 L 326 174.5 L 325 174.5 L 325.5 171 Z "
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 172 L 345 173.5 L 344 173.5 L 344.5 172 Z "
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 172 L 358.5 173 L 358.5 172 Z "
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 174 L 359.5 175 L 359.5 174 Z "
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 299.5 176 L 299.5 177 L 299.5 176 Z "
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 326.5 177 L 326.5 178 L 326.5 177 Z "
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 178 L 342.5 179 L 342.5 178 Z "
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 180 L 296.5 181 L 296.5 180 Z "
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 180 L 340.5 181 L 340.5 180 Z "
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 181 L 330.5 182 L 330.5 181 Z "
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 181 L 362.5 182 L 362.5 181 Z "
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 333.5 182 L 337 182.5 L 333.5 183 L 333.5 182 Z "
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 183 L 294.5 184 L 294.5 183 Z "
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 363.5 184 L 363.5 185 L 363.5 184 Z "
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366.5 193 L 366.5 194 L 366.5 193 Z "
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367.5 196 L 367.5 197 L 367.5 196 Z "
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 287.5 197 L 287.5 198 L 287.5 197 Z "
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 286.5 200 L 286.5 201 L 286.5 200 Z "
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 200 L 368.5 201 L 368.5 200 Z "
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 316.5 203 L 316.5 204 L 316.5 203 Z "
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 204 L 319.5 205 L 319.5 204 Z "
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 205 L 321.5 206 L 321.5 205 Z "
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 205 L 369.5 206 L 369.5 205 Z "
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 206 L 300.5 207 L 300.5 206 Z "
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 207 L 327 209.5 L 326.5 210 L 324 207.5 L 324.5 207 Z "
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 283.5 210 L 283.5 211 L 283.5 210 Z "
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 210 L 371 211.5 L 370 211.5 L 370.5 210 Z "
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 215 L 293.5 216 L 293.5 215 Z "
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 216 L 330.5 217 L 330.5 216 Z "
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 217 L 372 218.5 L 371 218.5 L 371.5 217 Z "
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 201.5 218 L 201.5 219 L 201.5 218 Z "
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 220 L 199.5 221 L 199.5 220 Z "
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 222 L 331.5 223 L 331.5 222 Z "
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 222 L 350.5 223 L 350.5 222 Z "
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 222 L 357 222.5 L 355.5 223 L 355.5 222 Z "
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 281.5 223 L 281.5 224 L 281.5 223 Z "
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 223 L 348.5 224 L 348.5 223 Z "
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 223 L 358.5 224 L 358.5 223 Z "
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 330.5 228 L 330.5 229 L 330.5 228 Z "
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 228 L 344.5 229 L 344.5 228 Z "
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 228 L 373 245.5 L 372 245.5 L 372.5 228 Z "
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 229 L 235.5 230 L 235.5 229 Z "
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 293.5 229 L 293.5 230 L 293.5 229 Z "
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 236.5 232 L 236.5 233 L 236.5 232 Z "
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 233 L 295.5 234 L 295.5 233 Z "
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 234 L 345 235.5 L 344 235.5 L 344.5 234 Z "
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 237.5 235 L 237.5 236 L 237.5 235 Z "
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 326.5 235 L 326.5 236 L 326.5 235 Z "
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 237 L 218.5 238 L 218.5 237 Z "
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 324.5 237 L 324.5 238 L 324.5 237 Z "
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 238.5 238 L 238.5 239 L 238.5 238 Z "
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 239 L 348.5 240 L 348.5 239 Z "
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 239 L 358.5 240 L 358.5 239 Z "
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 455.5 239 L 455.5 240 L 455.5 239 Z "
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 240 L 205.5 241 L 205.5 240 Z "
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 240 L 213.5 241 L 213.5 240 Z "
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 240 L 350.5 241 L 350.5 240 Z "
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 240 L 356.5 241 L 356.5 240 Z "
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 239.5 241 L 239.5 242 L 239.5 241 Z "
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 240.5 244 L 240.5 245 L 240.5 244 Z "
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 454.5 246 L 454.5 247 L 454.5 246 Z "
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 453.5 251 L 453.5 252 L 453.5 251 Z "
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 255 L 372 256.5 L 371 256.5 L 371.5 255 Z "
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 263 L 370.5 264 L 370.5 263 Z "
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 268 L 370 269.5 L 369 269.5 L 369.5 268 Z "
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 415.5 272 L 416 313.5 L 415 313.5 L 415.5 272 Z "
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 273 L 368.5 274 L 368.5 273 Z "
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 342.5 277 L 347 277.5 L 342.5 278 L 342.5 277 Z "
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367.5 277 L 367.5 278 L 367.5 277 Z "
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 278 L 340.5 279 L 340.5 278 Z "
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 278 L 348.5 279 L 348.5 278 Z "
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 338.5 279 Q 340 280 337.5 281 Q 336 280 338.5 279 Z "
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 279 L 353 281.5 L 352.5 282 L 350 279.5 L 350.5 279 Z "
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 252.5 280 L 252.5 281 L 252.5 280 Z "
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366.5 281 L 366.5 282 L 366.5 281 Z "
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 283 L 353.5 284 L 353.5 283 Z "
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 284 L 335.5 285 L 335.5 284 Z "
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 284 L 365.5 285 L 365.5 284 Z "
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 287 L 364.5 288 L 364.5 287 Z "
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 335.5 289 L 335.5 290 L 335.5 289 Z "
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 289 L 354 290.5 L 353 290.5 L 353.5 289 Z "
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 363.5 290 L 363.5 291 L 363.5 290 Z "
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 291 L 336.5 292 L 336.5 291 Z "
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 293 Q 353 294 350.5 295 Q 349 294 351.5 293 Z "
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 294 L 396 294.5 L 368 295 L 367.5 368 L 367 295.5 L 368.5 294 Z "
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 340.5 295 L 340.5 296 L 340.5 295 Z "
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 295 L 348.5 296 L 348.5 295 Z "
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 295 L 361.5 296 L 361.5 295 Z "
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 296 L 344.5 297 L 344.5 296 Z "
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 297 L 360.5 298 L 360.5 297 Z "
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 299 L 359.5 300 L 359.5 299 Z "
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 302 L 358.5 303 L 358.5 302 Z "
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 301.5 305 L 306 305.5 L 301.5 306 L 301.5 305 Z "
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 356.5 305 L 356.5 306 L 356.5 305 Z "
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 306 Q 300 307 297.5 308 Q 296 307 298.5 306 Z "
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 306 L 307.5 307 L 307.5 306 Z "
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 307 L 355.5 308 L 355.5 307 Z "
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 309 L 295.5 310 L 295.5 309 Z "
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 354.5 309 L 354.5 310 L 354.5 309 Z "
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 311.5 310 L 311.5 311 L 311.5 310 Z "
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 311 L 294.5 312 L 294.5 311 Z "
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 312.5 312 L 313 316.5 L 312 316.5 L 312.5 312 Z "
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 352.5 312 L 352.5 313 L 352.5 312 Z "
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 350.5 315 L 350.5 316 L 350.5 315 Z "
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 318 L 294.5 319 L 294.5 318 Z "
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 348.5 318 L 349 318.5 L 346.5 321 L 346 320.5 L 348.5 318 Z "
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 311.5 319 L 311.5 320 L 311.5 319 Z "
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 295.5 320 L 298 322.5 L 297.5 323 L 295 320.5 L 295.5 320 Z "
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 322 L 308.5 323 L 308.5 322 Z "
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 299.5 323 L 299.5 324 L 299.5 323 Z "
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 324 L 303.5 325 L 303.5 324 Z "
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 341.5 326 Q 343 327 340.5 328 Q 339 327 341.5 326 Z "
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 336.5 330 Q 338 331 335.5 332 Q 334 331 336.5 330 Z "
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(195,197,223)",
    stroke: "rgb(195,197,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 332.5 333 L 332.5 334 L 332.5 333 Z "
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,234,234)",
    stroke: "rgb(234,234,234)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 375.5 144 L 376.5 145 L 383.5 145 Q 384.5 147 388.5 146 L 403.5 151 L 411.5 155 L 425 168.5 L 406 188.5 L 406 190.5 L 455 239.5 L 455 244.5 L 454 245.5 L 454 249.5 L 453 250.5 L 453 253.5 L 451 257.5 L 451 260 L 449.5 260 L 379 189.5 L 399 168.5 L 375 144.5 L 375.5 144 Z "
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(234,234,234)",
    stroke: "rgb(234,234,234)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 397.5 272 L 400.5 274 L 410.5 274 L 414.5 272 L 415 313 L 387.5 313 L 386 314.5 L 386 367.5 L 385.5 368 L 368 368 L 368 295.5 L 368.5 295 L 397 295 L 397.5 272 Z "
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(5,57,75)",
    stroke: "rgb(5,57,75)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 204 L 317.5 204 L 327 210.5 L 331 219.5 L 331 225.5 L 329 231.5 L 323.5 238 L 317.5 241 Q 313.33 240.33 311.5 242 L 310.5 241 L 306.5 241 L 301.5 239 L 296 233.5 L 293 227.5 L 293 218.5 L 296 211.5 L 300.5 207 L 306.5 204 Z M 309 213 L 307 214 L 302 220 Q 301 225 303 228 L 309 232 Q 315 233 318 231 L 320 229 L 322 224 L 320 217 L 316 213 L 309 213 Z "
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(5,57,75)",
    stroke: "rgb(5,57,75)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 234 L 410.5 234 L 413.5 235 L 422 241.5 L 426 250.5 L 426 256.5 L 423 264.5 L 416.5 271 L 411.5 273 L 400.5 273 L 395.5 271 L 389 264.5 L 386 257.5 L 386 250.5 L 388 244.5 L 393.5 238 L 401.5 234 Z "
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 256 L 122 256.5 L 119.5 257 L 119.5 256 Z "
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 256 L 129 256.5 L 127.5 257 L 127.5 256 Z "
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 257 L 117.5 258 L 117.5 257 Z "
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 257 L 131.5 258 L 131.5 257 Z "
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 258 L 115.5 259 L 115.5 258 Z "
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 258 L 133.5 259 L 133.5 258 Z "
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 259 L 114 259.5 L 108.5 265 L 108 264.5 L 113.5 259 Z "
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 259 L 141 264.5 L 140.5 265 L 135 259.5 L 135.5 259 Z "
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 266 L 107.5 267 L 107.5 266 Z "
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 266 L 141.5 267 L 141.5 266 Z "
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 268 L 106.5 269 L 106.5 268 Z "
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 268 L 143 269.5 L 142 269.5 L 142.5 268 Z "
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 271 L 106 300.5 Q 105 303 104 301.5 L 105 300.5 L 105.5 271 Z "
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 272 L 144 311 L 146 311.5 L 144.5 312 L 143 310.5 L 143.5 272 Z "
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 298 L 94 298.5 L 92.5 299 L 92.5 298 Z "
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 299 L 98 299.5 L 96.5 300 L 96.5 299 Z "
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 300 L 102 300.5 L 100.5 301 L 100.5 300 Z "
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 312 L 150 312.5 L 148.5 313 L 148.5 312 Z "
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,207,187)",
    stroke: "rgb(255,207,187)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 313 L 154 313.5 L 152.5 314 L 152.5 313 Z "
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 511.5 250 L 512 251.5 L 511 251.5 L 511.5 250 Z "
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 511.5 261 L 512 272.5 L 511 272.5 L 511.5 261 Z "
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 510.5 279 L 511 283.5 L 510 283.5 L 510.5 279 Z "
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 509.5 288 L 510 291.5 L 509 291.5 L 509.5 288 Z "
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 508.5 295 L 509 298.5 L 508 298.5 L 508.5 295 Z "
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 507.5 301 L 508 303.5 L 507 303.5 L 507.5 301 Z "
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 506.5 307 L 507 308.5 L 506 308.5 L 506.5 307 Z "
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 505.5 311 L 506 313.5 L 505 313.5 L 505.5 311 Z "
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 504.5 316 L 505 317.5 L 504 317.5 L 504.5 316 Z "
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 503.5 320 L 504 321.5 L 503 321.5 L 503.5 320 Z "
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 502.5 323 L 503 324.5 L 502 324.5 L 502.5 323 Z "
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 501.5 327 L 502 328.5 L 501 328.5 L 501.5 327 Z "
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 500.5 330 L 501 331.5 L 500 331.5 L 500.5 330 Z "
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 499.5 334 L 499.5 335 L 499.5 334 Z "
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 498.5 337 L 498.5 338 L 498.5 337 Z "
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 497.5 340 L 497.5 341 L 497.5 340 Z "
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 496.5 342 L 497 343.5 L 496 343.5 L 496.5 342 Z "
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 495.5 345 L 496 346.5 L 495 346.5 L 495.5 345 Z "
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 494.5 348 L 494.5 349 L 494.5 348 Z "
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 493.5 350 L 494 351.5 L 493 351.5 L 493.5 350 Z "
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 492.5 353 L 492.5 354 L 492.5 353 Z "
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 491.5 355 L 492 356.5 L 491 356.5 L 491.5 355 Z "
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 490.5 358 L 490.5 359 L 490.5 358 Z "
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 489.5 360 L 489.5 361 L 489.5 360 Z "
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 488.5 362 L 488.5 363 L 488.5 362 Z "
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 487.5 364 L 487.5 365 L 487.5 364 Z "
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 486.5 366 L 487 367.5 L 482.5 375 L 483 373.5 L 486.5 366 Z "
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 481.5 376 L 481.5 377 L 481.5 376 Z "
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 480.5 378 L 480.5 379 L 480.5 378 Z "
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 479.5 380 L 479.5 381 L 479.5 380 Z "
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 478.5 382 Q 480 383 477.5 384 Q 476 383 478.5 382 Z "
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 476.5 385 L 476.5 386 L 476.5 385 Z "
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 475.5 387 Q 477 388 474.5 389 Q 473 388 475.5 387 Z "
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 473.5 390 L 473.5 391 L 473.5 390 Z "
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 472.5 392 Q 474 393 471.5 394 Q 470 393 472.5 392 Z "
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 470.5 395 Q 472 396 469.5 397 Q 468 396 470.5 395 Z "
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 468.5 398 Q 470 399 467.5 400 Q 466 399 468.5 398 Z "
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 466.5 401 Q 468 402 465.5 403 Q 464 402 466.5 401 Z "
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 464.5 404 L 465 404.5 L 462.5 407 L 462 406.5 L 464.5 404 Z "
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 461.5 408 L 462 408.5 L 459.5 411 L 459 410.5 L 461.5 408 Z "
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 458.5 412 L 459 412.5 L 456.5 415 L 456 414.5 L 458.5 412 Z "
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 454.5 417 L 455 417.5 L 451.5 421 L 451 420.5 L 454.5 417 Z "
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 449.5 423 L 450 423.5 L 444.5 429 L 444 428.5 L 449.5 423 Z "
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 439.5 434 L 440 434.5 L 434.5 440 L 434 439.5 L 439.5 434 Z "
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 428.5 444 L 429 444.5 L 422.5 451 L 422 450.5 L 428.5 444 Z "
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 420.5 451 L 421 451.5 L 417.5 455 L 417 454.5 L 420.5 451 Z "
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 414.5 456 L 415 456.5 L 412.5 459 L 412 458.5 L 414.5 456 Z "
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 410.5 459 L 411 459.5 L 408.5 462 L 408 461.5 L 410.5 459 Z "
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 406.5 462 L 407 462.5 L 404.5 465 L 404 464.5 L 406.5 462 Z "
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 402.5 465 Q 404 466 401.5 467 Q 400 466 402.5 465 Z "
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 399.5 467 Q 401 468 398.5 469 Q 397 468 399.5 467 Z "
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 396.5 469 Q 398 470 395.5 471 Q 394 470 396.5 469 Z "
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 393.5 471 Q 395 472 392.5 473 Q 391 472 393.5 471 Z "
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 390.5 473 Q 392 474 389.5 475 Q 388 474 390.5 473 Z "
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 387.5 475 L 387.5 476 L 387.5 475 Z "
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 385.5 476 L 385.5 477 L 385.5 476 Z "
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 383.5 477 Q 385 478 382.5 479 Q 381 478 383.5 477 Z "
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 380.5 479 L 380.5 480 L 380.5 479 Z "
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 378.5 480 L 378.5 481 L 378.5 480 Z "
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 376.5 481 Q 378 482 375.5 483 L 364.5 488 L 364.5 487 L 376.5 481 Z "
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 362.5 488 L 362.5 489 L 362.5 488 Z "
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 360.5 489 L 360.5 490 L 360.5 489 Z "
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 358.5 490 L 358.5 491 L 358.5 490 Z "
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 355.5 491 L 357 491.5 L 355.5 492 L 355.5 491 Z "
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 353.5 492 L 353.5 493 L 353.5 492 Z "
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 350.5 493 L 352 493.5 L 350.5 494 L 350.5 493 Z "
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 348.5 494 L 348.5 495 L 348.5 494 Z "
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 345.5 495 L 347 495.5 L 345.5 496 L 345.5 495 Z "
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 342.5 496 L 344 496.5 L 342.5 497 L 342.5 496 Z "
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 340.5 497 L 340.5 498 L 340.5 497 Z "
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 337.5 498 L 337.5 499 L 337.5 498 Z "
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 334.5 499 L 334.5 500 L 334.5 499 Z "
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 330.5 500 L 332 500.5 L 330.5 501 L 330.5 500 Z "
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 327.5 501 L 329 501.5 L 327.5 502 L 327.5 501 Z "
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 324.5 502 L 324.5 503 L 324.5 502 Z "
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 320.5 503 L 322 503.5 L 320.5 504 L 320.5 503 Z "
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 316.5 504 L 318 504.5 L 316.5 505 L 316.5 504 Z "
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 311.5 505 L 314 505.5 L 311.5 506 L 311.5 505 Z "
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 307.5 506 L 309 506.5 L 307.5 507 L 307.5 506 Z "
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 301.5 507 L 304 507.5 L 301.5 508 L 301.5 507 Z "
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 295.5 508 L 299 508.5 L 295.5 509 L 295.5 508 Z "
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 288.5 509 L 292 509.5 L 288.5 510 L 288.5 509 Z "
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 279.5 510 L 284 510.5 L 279.5 511 L 279.5 510 Z "
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 239.5 511 L 254 511.5 L 239.5 512 L 239.5 511 Z "
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 0.996078431372549,
    d: "M 260.5 511 L 272 511.5 L 260.5 512 L 260.5 511 Z "
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 235.5 145 L 287 196.5 L 287 198.5 L 285 201.5 L 285 204.5 L 283 208.5 L 283 212.5 L 281 218.5 L 281 225.5 L 262 280.5 L 284 281 L 284 334 L 332 334 L 332 369 L 425 369 L 425 298.5 L 440 282.5 L 444 276.5 L 452 259.5 L 454 249.5 L 455 248.5 L 455 244.5 L 456 243.5 L 456 218.5 L 455 217.5 L 454 208.5 L 451 199.5 L 448 194.5 L 448 192.5 L 438 177.5 L 438.5 177 L 511 249.5 L 512 252.5 L 512 260.5 L 511 261.5 L 511 278.5 L 510 279.5 L 510 287.5 L 509 288.5 L 509 294.5 L 508 295.5 L 507 306.5 L 506 307.5 L 505 315.5 L 502 323.5 L 502 326.5 L 500 330.5 L 500 333.5 L 496 342.5 L 495 347.5 L 493 350.5 L 493 352.5 L 491 355.5 L 491 357.5 L 479 381.5 L 465 403.5 L 444 429.5 L 429.5 444 L 415.5 456 L 388.5 475 L 357.5 491 L 355.5 491 L 347.5 495 L 323.5 503 L 320.5 503 L 315.5 505 L 311.5 505 L 306.5 507 L 301.5 507 L 300.5 508 Q 295.75 506.75 294.5 509 L 288.5 509 L 287.5 510 L 279.5 510 L 278.5 511 L 260.5 511 Q 259.25 513.25 254.5 512 L 253.5 511 L 233.5 511 L 92 369.5 L 184 369 L 184 334 L 231 334 L 231 281 L 252.5 281 L 253 279.5 L 235 227.5 Q 236 223.5 234 222.5 L 234 215.5 L 233 214.5 L 232 206.5 L 229 197.5 L 223 186.5 L 223 183.5 L 228 173.5 L 228 170.5 L 229 169.5 L 229 166.5 L 230 165.5 L 233 150.5 L 234 149.5 L 234 146.5 L 235.5 145 Z "
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 213 L 308.5 214 L 308.5 213 Z "
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 314.5 213 L 316 213.5 L 314.5 214 L 314.5 213 Z "
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 214 L 307 214.5 L 303.5 218 L 303 217.5 L 306.5 214 Z "
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 318.5 215 Q 321 216 319.5 217 Q 317 216 318.5 215 Z "
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 218 L 320.5 219 L 320.5 218 Z "
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 219 L 303 220.5 L 302 220.5 L 302.5 219 Z "
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 221 L 322 223.5 L 321 223.5 L 321.5 221 Z "
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 224 L 303 225.5 L 302 225.5 L 302.5 224 Z "
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 320.5 226 L 320.5 227 L 320.5 226 Z "
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 303.5 227 L 303.5 228 L 303.5 227 Z "
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 319.5 228 L 320 228.5 L 317.5 231 L 317 230.5 L 319.5 228 Z "
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 306.5 230 L 306.5 231 L 306.5 230 Z "
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 308.5 231 L 308.5 232 L 308.5 231 Z "
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 315.5 231 L 315.5 232 L 315.5 231 Z "
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,83,191)",
    stroke: "rgb(0,83,191)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 290 L 91 298 L 91 321.5 L 89.5 322 L 58 290.5 L 58.5 290 Z "
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 144 L 380.5 145 L 380.5 144 Z "
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 353.5 145 Q 358.88 144.38 359 145.5 L 359 171.5 L 358 171.5 Q 352.09 157.91 342 148.5 L 344.5 147 L 352.5 146 L 353.5 145 Z "
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 386.5 145 L 386.5 146 L 386.5 145 Z "
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 317.5 159 L 317.5 160 L 317.5 159 Z "
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 331.5 164 L 338.5 164 Q 339.5 166.5 342 166 Q 341.5 168.5 344 169.5 L 344 176.5 Q 341.5 177.5 342 180 Q 339.5 179.5 338.5 182 L 331.5 182 L 327 178.5 Q 324.83 175.67 326 169.5 L 328.5 166 L 331.5 164 Z "
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 360.5 176 L 360.5 177 L 360.5 176 Z "
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 178 L 361.5 179 L 361.5 178 Z "
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 363.5 183 L 363.5 184 L 363.5 183 Z "
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 364.5 186 L 364.5 187 L 364.5 186 Z "
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 189 L 365.5 190 L 365.5 189 Z "
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 378.5 189 L 450 260.5 L 449.5 261 L 378 189.5 L 378.5 189 Z "
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 366.5 192 L 366.5 193 L 366.5 192 Z "
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 229.5 201 L 229.5 202 L 229.5 201 Z "
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 204 L 369.5 205 L 369.5 204 Z "
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 284.5 206 L 284.5 207 L 284.5 206 Z "
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 209 L 370.5 210 L 370.5 209 Z "
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 232.5 212 L 232.5 213 L 232.5 212 Z "
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 213 L 294.5 214 L 294.5 213 Z "
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 282.5 215 L 282.5 216 L 282.5 215 Z "
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 216 L 371.5 217 L 371.5 216 Z "
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 217.5 218 L 217.5 219 L 217.5 218 Z "
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 218 L 233.5 219 L 233.5 218 Z "
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 219 L 200.5 220 L 200.5 219 Z "
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 292.5 219 L 292.5 220 L 292.5 219 Z "
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 219.5 220 L 219.5 221 L 219.5 220 Z "
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 351.5 222 L 354.5 222 L 360 224.5 L 359 225.5 L 359 237.5 L 359.5 239 L 355.5 241 L 351.5 241 L 345 236.5 L 344 229.5 L 345 226.5 L 347.5 224 L 351.5 222 Z "
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 440.5 223 L 455 237.5 L 454.5 238 L 440 223.5 L 440.5 223 Z "
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 234.5 226 L 234.5 227 L 234.5 226 Z "
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 226 L 361.5 227 L 361.5 226 Z "
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 226 L 373 227.5 L 372 227.5 L 372.5 226 Z "
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 228 L 362.5 229 L 362.5 228 Z "
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 232 L 197.5 233 L 197.5 232 Z "
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 232 L 221.5 233 L 221.5 232 Z "
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 234 L 362.5 235 L 362.5 234 Z "
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 325.5 236 L 325.5 237 L 325.5 236 Z "
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 361.5 236 L 361.5 237 L 361.5 236 Z "
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 300.5 238 L 300.5 239 L 300.5 238 Z "
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 239 L 203.5 240 L 203.5 239 Z "
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 321.5 239 L 321.5 240 L 321.5 239 Z "
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 455.5 240 L 455.5 241 L 455.5 240 Z "
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 246 L 373 248.5 L 372 248.5 L 372.5 246 Z "
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 452.5 255 L 452.5 256 L 452.5 255 Z "
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 371.5 257 L 372 258.5 L 371 258.5 L 371.5 257 Z "
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 451.5 258 L 451.5 259 L 451.5 258 Z "
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 370.5 264 L 370.5 265 L 370.5 264 Z "
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 270 L 369.5 271 L 369.5 270 Z "
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 273 L 401.5 274 L 401.5 273 Z "
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 410.5 273 L 410.5 274 L 410.5 273 Z "
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 368.5 274 L 368.5 275 L 368.5 274 Z "
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 341.5 278 L 347.5 278 L 353 282.5 Q 354.67 284.33 354 288.5 L 353 291.5 L 349.5 295 Q 347 297 341.5 296 L 337 292.5 L 335 288.5 L 335 285.5 L 336 282.5 L 339.5 279 L 341.5 278 Z "
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367.5 278 L 367.5 279 L 367.5 278 Z "
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 365.5 285 L 365.5 286 L 365.5 285 Z "
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 362.5 293 L 362.5 294 L 362.5 293 Z "
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 367.5 294 L 367.5 295 L 367.5 294 Z "
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359.5 300 L 359.5 301 L 359.5 300 Z "
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 358.5 303 L 359 368 L 332 368 L 332 334.5 L 342 326.5 L 349 318.5 L 358.5 303 Z "
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(183,186,223)",
    stroke: "rgb(183,186,223)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 299.5 306 Q 308.53 304.47 311 309.5 Q 313.17 312.33 312 318.5 L 309.5 322 L 306.5 324 L 300.5 324 L 295 319.5 Q 293.17 317.33 294 312.5 L 296 308 Q 298.5 308.5 299.5 306 Z "
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359 144 L 373.5 144 L 398 168.5 L 378 189.5 L 450 261.5 L 450 263.5 Q 440.9 284.9 424 298.5 L 424 337.5 L 425 338.5 L 425 368 L 387 368 L 387 314 L 416 314 L 416 271.5 L 417.5 271 Q 423.42 266.92 426 259.5 L 426 248.5 L 424 243.5 L 419.5 238 L 412.5 234 L 404.5 233 L 395.5 236 L 390 240.5 L 386 248.5 L 386 259.5 Q 388.58 266.92 394.5 271 L 396 271.5 L 396 294 L 367 294 L 367 367.5 L 366.5 368 L 359 368 L 359 301.5 L 366 285.5 L 366 282.5 L 370 270.5 L 370 265.5 L 371 264.5 Q 369.75 259.75 372 258.5 L 372 249.5 L 373 248.5 L 373 226.5 L 372 225.5 L 372 216.5 L 371 215.5 L 371 209.5 L 370 208.5 L 370 204.5 L 369 203.5 L 367 192.5 L 364 183.5 L 362 180.5 L 362 178.5 L 359 173.5 L 359 144 Z "
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 146 L 347.5 147 L 347.5 146 Z "
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 415.5 157 Q 427.96 165.04 437 176.5 L 444 186.5 L 450 198.5 L 453 207.5 L 454 215.5 L 455 216.5 L 455 222.5 L 456 223.5 L 456 238.5 L 455 238.5 L 440.5 223 L 406 189.5 L 426 168.5 L 415 157.5 L 415.5 157 Z "
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 223.5 187 L 223.5 188 L 223.5 187 Z "
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 224.5 189 L 224.5 190 L 224.5 189 Z "
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 225.5 191 L 225.5 192 L 225.5 191 Z "
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 226.5 193 L 226.5 194 L 226.5 193 Z "
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 228.5 198 L 228.5 199 L 228.5 198 Z "
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 203 L 307.5 204 L 307.5 203 Z "
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 230.5 204 L 230.5 205 L 230.5 204 Z "
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 304.5 204 L 304.5 205 L 304.5 204 Z "
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 302.5 205 L 302.5 206 L 302.5 205 Z "
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 299.5 207 L 299.5 208 L 299.5 207 Z "
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 212 L 328.5 213 L 328.5 212 Z "
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 329.5 214 L 329.5 215 L 329.5 214 Z "
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 205.5 216 L 205.5 217 L 205.5 216 Z "
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 213.5 216 L 213.5 217 L 213.5 216 Z "
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 233.5 217 L 233.5 218 L 233.5 217 Z "
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 218.5 219 L 218.5 220 L 218.5 219 Z "
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 222 L 198.5 223 L 198.5 222 Z "
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 224 L 197.5 225 L 197.5 224 Z "
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 221.5 224 L 221.5 225 L 221.5 224 Z "
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 359 225 Q 361.67 223.88 361 226.5 Q 363.8 228.2 363 233.5 L 361 238 L 359 237.5 L 359 225 Z "
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 294.5 231 L 294.5 232 L 294.5 231 Z "
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 328.5 232 L 328.5 233 L 328.5 232 Z "
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 198.5 234 L 198.5 235 L 198.5 234 Z "
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 220.5 234 L 220.5 235 L 220.5 234 Z "
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 296.5 234 L 296.5 235 L 296.5 234 Z "
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 215.5 239 L 215.5 240 L 215.5 239 Z "
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 307.5 241 L 307.5 242 L 307.5 241 Z "
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 455.5 241 L 455.5 242 L 455.5 241 Z "
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 398.5 272 L 398.5 273 L 398.5 272 Z "
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(163,164,207)",
    stroke: "rgb(163,164,207)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 413.5 272 L 413.5 273 L 413.5 272 Z "
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,212,202)",
    stroke: "rgb(255,212,202)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 256 Q 135.95 256.55 141 265.5 L 143 270.5 L 143 310.5 L 144.5 312 L 147.5 312 L 148.5 313 L 151.5 313 L 154 314 L 154 368 L 91 368 L 91.5 298 L 92.5 299 L 95.5 299 L 104.5 302 L 106 300.5 L 106 269.5 Q 108.67 262.67 114.5 259 L 122.5 256 Z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.033beacdd4b1c6de5481f89aee991a58.svg";
export { ForwardRef as ReactComponent };